"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.WALLETCONNECT_CLIENT_ID = exports.Verify = exports.VERIFY_SERVER = exports.VERIFY_CONTEXT = exports.Subscriber = exports.Store = exports.SUBSCRIBER_STORAGE_VERSION = exports.SUBSCRIBER_EVENTS = exports.SUBSCRIBER_DEFAULT_TTL = exports.SUBSCRIBER_CONTEXT = exports.STORE_STORAGE_VERSION = exports.Relayer = exports.RELAYER_TRANSPORT_CUTOFF = exports.RELAYER_SUBSCRIBER_SUFFIX = exports.RELAYER_STORAGE_OPTIONS = exports.RELAYER_SDK_VERSION = exports.RELAYER_RECONNECT_TIMEOUT = exports.RELAYER_PROVIDER_EVENTS = exports.RELAYER_EVENTS = exports.RELAYER_DEFAULT_RELAY_URL = exports.RELAYER_DEFAULT_PROTOCOL = exports.RELAYER_DEFAULT_LOGGER = exports.RELAYER_CONTEXT = exports.Pairing = exports.PUBLISHER_DEFAULT_TTL = exports.PUBLISHER_CONTEXT = exports.PENDING_SUB_RESOLUTION_TIMEOUT = exports.PAIRING_STORAGE_VERSION = exports.PAIRING_RPC_OPTS = exports.PAIRING_DEFAULT_TTL = exports.PAIRING_CONTEXT = exports.MessageTracker = exports.MESSAGES_STORAGE_VERSION = exports.MESSAGES_CONTEXT = exports.KeyChain = exports.KEYCHAIN_STORAGE_VERSION = exports.KEYCHAIN_CONTEXT = exports.JsonRpcHistory = exports.HISTORY_STORAGE_VERSION = exports.HISTORY_EVENTS = exports.HISTORY_CONTEXT = exports.Expirer = exports.EXPIRER_STORAGE_VERSION = exports.EXPIRER_EVENTS = exports.EXPIRER_DEFAULT_TTL = exports.EXPIRER_CONTEXT = exports.Crypto = exports.Core = exports.CRYPTO_JWT_TTL = exports.CRYPTO_CONTEXT = exports.CRYPTO_CLIENT_SEED = exports.CORE_VERSION = exports.CORE_STORAGE_PREFIX = exports.CORE_STORAGE_OPTIONS = exports.CORE_PROTOCOL = exports.CORE_DEFAULT = exports.CORE_CONTEXT = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _events = _interopRequireWildcard(require("events"));

var _keyvaluestorage = _interopRequireDefault(require("@walletconnect/keyvaluestorage"));

var _heartbeat = require("@walletconnect/heartbeat");

var _logger = require("@walletconnect/logger");

var _types = require("@walletconnect/types");

var _safeJson = require("@walletconnect/safe-json");

var j = _interopRequireWildcard(require("@walletconnect/relay-auth"));

var _utils = require("@walletconnect/utils");

var _uint8arrays = require("uint8arrays");

var _time = require("@walletconnect/time");

var _jsonrpcProvider = require("@walletconnect/jsonrpc-provider");

var _jsonrpcUtils = require("@walletconnect/jsonrpc-utils");

var _jsonrpcWsConnection = _interopRequireDefault(require("@walletconnect/jsonrpc-ws-connection"));

var _lodash = _interopRequireDefault(require("lodash.isequal"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function Li(r, e) {
  if (r.length >= 255) throw new TypeError("Alphabet too long");

  for (var t = new Uint8Array(256), i = 0; i < t.length; i++) {
    t[i] = 255;
  }

  for (var s = 0; s < r.length; s++) {
    var n = r.charAt(s),
        a = n.charCodeAt(0);
    if (t[a] !== 255) throw new TypeError(n + " is ambiguous");
    t[a] = s;
  }

  var o = r.length,
      h = r.charAt(0),
      d = Math.log(o) / Math.log(256),
      l = Math.log(256) / Math.log(o);

  function D(u) {
    if (u instanceof Uint8Array || (ArrayBuffer.isView(u) ? u = new Uint8Array(u.buffer, u.byteOffset, u.byteLength) : Array.isArray(u) && (u = Uint8Array.from(u))), !(u instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
    if (u.length === 0) return "";

    for (var y = 0, A = 0, v = 0, R = u.length; v !== R && u[v] === 0;) {
      v++, y++;
    }

    for (var T = (R - v) * l + 1 >>> 0, m = new Uint8Array(T); v !== R;) {
      for (var S = u[v], x = 0, I = T - 1; (S !== 0 || x < A) && I !== -1; I--, x++) {
        S += 256 * m[I] >>> 0, m[I] = S % o >>> 0, S = S / o >>> 0;
      }

      if (S !== 0) throw new Error("Non-zero carry");
      A = x, v++;
    }

    for (var P = T - A; P !== T && m[P] === 0;) {
      P++;
    }

    for (var B = h.repeat(y); P < T; ++P) {
      B += r.charAt(m[P]);
    }

    return B;
  }

  function b(u) {
    if (typeof u != "string") throw new TypeError("Expected String");
    if (u.length === 0) return new Uint8Array();
    var y = 0;

    if (u[y] !== " ") {
      for (var A = 0, v = 0; u[y] === h;) {
        A++, y++;
      }

      for (var R = (u.length - y) * d + 1 >>> 0, T = new Uint8Array(R); u[y];) {
        var m = t[u.charCodeAt(y)];
        if (m === 255) return;

        for (var S = 0, x = R - 1; (m !== 0 || S < v) && x !== -1; x--, S++) {
          m += o * T[x] >>> 0, T[x] = m % 256 >>> 0, m = m / 256 >>> 0;
        }

        if (m !== 0) throw new Error("Non-zero carry");
        v = S, y++;
      }

      if (u[y] !== " ") {
        for (var I = R - v; I !== R && T[I] === 0;) {
          I++;
        }

        for (var P = new Uint8Array(A + (R - I)), B = A; I !== R;) {
          P[B++] = T[I++];
        }

        return P;
      }
    }
  }

  function k(u) {
    var y = b(u);
    if (y) return y;
    throw new Error("Non-".concat(e, " character"));
  }

  return {
    encode: D,
    decodeUnsafe: b,
    decode: k
  };
}

var Fi = Li,
    $i = Fi;

var Pe = function Pe(r) {
  if (r instanceof Uint8Array && r.constructor.name === "Uint8Array") return r;
  if (r instanceof ArrayBuffer) return new Uint8Array(r);
  if (ArrayBuffer.isView(r)) return new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
  throw new Error("Unknown type, must be binary type");
},
    Mi = function Mi(r) {
  return new TextEncoder().encode(r);
},
    Ki = function Ki(r) {
  return new TextDecoder().decode(r);
};

var ki = /*#__PURE__*/function () {
  function ki(e, t, i) {
    _classCallCheck(this, ki);

    this.name = e, this.prefix = t, this.baseEncode = i;
  }

  _createClass(ki, [{
    key: "encode",
    value: function encode(e) {
      if (e instanceof Uint8Array) return "".concat(this.prefix).concat(this.baseEncode(e));
      throw Error("Unknown type, must be binary type");
    }
  }]);

  return ki;
}();

var Bi = /*#__PURE__*/function () {
  function Bi(e, t, i) {
    _classCallCheck(this, Bi);

    if (this.name = e, this.prefix = t, t.codePointAt(0) === void 0) throw new Error("Invalid prefix character");
    this.prefixCodePoint = t.codePointAt(0), this.baseDecode = i;
  }

  _createClass(Bi, [{
    key: "decode",
    value: function decode(e) {
      if (typeof e == "string") {
        if (e.codePointAt(0) !== this.prefixCodePoint) throw Error("Unable to decode multibase string ".concat(JSON.stringify(e), ", ").concat(this.name, " decoder only supports inputs prefixed with ").concat(this.prefix));
        return this.baseDecode(e.slice(this.prefix.length));
      } else throw Error("Can only multibase decode strings");
    }
  }, {
    key: "or",
    value: function or(e) {
      return Oe(this, e);
    }
  }]);

  return Bi;
}();

var ji = /*#__PURE__*/function () {
  function ji(e) {
    _classCallCheck(this, ji);

    this.decoders = e;
  }

  _createClass(ji, [{
    key: "or",
    value: function or(e) {
      return Oe(this, e);
    }
  }, {
    key: "decode",
    value: function decode(e) {
      var t = e[0],
          i = this.decoders[t];
      if (i) return i.decode(e);
      throw RangeError("Unable to decode multibase string ".concat(JSON.stringify(e), ", only inputs prefixed with ").concat(Object.keys(this.decoders), " are supported"));
    }
  }]);

  return ji;
}();

var Oe = function Oe(r, e) {
  return new ji(_objectSpread(_objectSpread({}, r.decoders || _defineProperty({}, r.prefix, r)), e.decoders || _defineProperty({}, e.prefix, e)));
};

var Vi = /*#__PURE__*/function () {
  function Vi(e, t, i, s) {
    _classCallCheck(this, Vi);

    this.name = e, this.prefix = t, this.baseEncode = i, this.baseDecode = s, this.encoder = new ki(e, t, i), this.decoder = new Bi(e, t, s);
  }

  _createClass(Vi, [{
    key: "encode",
    value: function encode(e) {
      return this.encoder.encode(e);
    }
  }, {
    key: "decode",
    value: function decode(e) {
      return this.decoder.decode(e);
    }
  }]);

  return Vi;
}();

var G = function G(_ref3) {
  var r = _ref3.name,
      e = _ref3.prefix,
      t = _ref3.encode,
      i = _ref3.decode;
  return new Vi(r, e, t, i);
},
    M = function M(_ref4) {
  var r = _ref4.prefix,
      e = _ref4.name,
      t = _ref4.alphabet;

  var _$i = $i(t, e),
      i = _$i.encode,
      s = _$i.decode;

  return G({
    prefix: r,
    name: e,
    encode: i,
    decode: function decode(n) {
      return Pe(s(n));
    }
  });
},
    qi = function qi(r, e, t, i) {
  var s = {};

  for (var l = 0; l < e.length; ++l) {
    s[e[l]] = l;
  }

  var n = r.length;

  for (; r[n - 1] === "=";) {
    --n;
  }

  var a = new Uint8Array(n * t / 8 | 0);
  var o = 0,
      h = 0,
      d = 0;

  for (var _l = 0; _l < n; ++_l) {
    var D = s[r[_l]];
    if (D === void 0) throw new SyntaxError("Non-".concat(i, " character"));
    h = h << t | D, o += t, o >= 8 && (o -= 8, a[d++] = 255 & h >> o);
  }

  if (o >= t || 255 & h << 8 - o) throw new SyntaxError("Unexpected end of data");
  return a;
},
    Gi = function Gi(r, e, t) {
  var i = e[e.length - 1] === "=",
      s = (1 << t) - 1;
  var n = "",
      a = 0,
      o = 0;

  for (var h = 0; h < r.length; ++h) {
    for (o = o << 8 | r[h], a += 8; a > t;) {
      a -= t, n += e[s & o >> a];
    }
  }

  if (a && (n += e[s & o << t - a]), i) for (; n.length * t & 7;) {
    n += "=";
  }
  return n;
},
    p = function p(_ref5) {
  var r = _ref5.name,
      e = _ref5.prefix,
      t = _ref5.bitsPerChar,
      i = _ref5.alphabet;
  return G({
    prefix: e,
    name: r,
    encode: function encode(s) {
      return Gi(s, i, t);
    },
    decode: function decode(s) {
      return qi(s, i, t, r);
    }
  });
},
    Yi = G({
  prefix: "\0",
  name: "identity",
  encode: function encode(r) {
    return Ki(r);
  },
  decode: function decode(r) {
    return Mi(r);
  }
});

var Ji = Object.freeze({
  __proto__: null,
  identity: Yi
});
var Hi = p({
  prefix: "0",
  name: "base2",
  alphabet: "01",
  bitsPerChar: 1
});
var Wi = Object.freeze({
  __proto__: null,
  base2: Hi
});
var Xi = p({
  prefix: "7",
  name: "base8",
  alphabet: "01234567",
  bitsPerChar: 3
});
var Zi = Object.freeze({
  __proto__: null,
  base8: Xi
});
var Qi = M({
  prefix: "9",
  name: "base10",
  alphabet: "0123456789"
});
var es = Object.freeze({
  __proto__: null,
  base10: Qi
});
var ts = p({
  prefix: "f",
  name: "base16",
  alphabet: "0123456789abcdef",
  bitsPerChar: 4
}),
    is = p({
  prefix: "F",
  name: "base16upper",
  alphabet: "0123456789ABCDEF",
  bitsPerChar: 4
});
var ss = Object.freeze({
  __proto__: null,
  base16: ts,
  base16upper: is
});
var rs = p({
  prefix: "b",
  name: "base32",
  alphabet: "abcdefghijklmnopqrstuvwxyz234567",
  bitsPerChar: 5
}),
    ns = p({
  prefix: "B",
  name: "base32upper",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
  bitsPerChar: 5
}),
    as = p({
  prefix: "c",
  name: "base32pad",
  alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
  bitsPerChar: 5
}),
    os = p({
  prefix: "C",
  name: "base32padupper",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
  bitsPerChar: 5
}),
    hs = p({
  prefix: "v",
  name: "base32hex",
  alphabet: "0123456789abcdefghijklmnopqrstuv",
  bitsPerChar: 5
}),
    cs = p({
  prefix: "V",
  name: "base32hexupper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
  bitsPerChar: 5
}),
    us = p({
  prefix: "t",
  name: "base32hexpad",
  alphabet: "0123456789abcdefghijklmnopqrstuv=",
  bitsPerChar: 5
}),
    ls = p({
  prefix: "T",
  name: "base32hexpadupper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
  bitsPerChar: 5
}),
    ds = p({
  prefix: "h",
  name: "base32z",
  alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
  bitsPerChar: 5
});
var gs = Object.freeze({
  __proto__: null,
  base32: rs,
  base32upper: ns,
  base32pad: as,
  base32padupper: os,
  base32hex: hs,
  base32hexupper: cs,
  base32hexpad: us,
  base32hexpadupper: ls,
  base32z: ds
});
var ps = M({
  prefix: "k",
  name: "base36",
  alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}),
    Ds = M({
  prefix: "K",
  name: "base36upper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
var ys = Object.freeze({
  __proto__: null,
  base36: ps,
  base36upper: Ds
});
var bs = M({
  name: "base58btc",
  prefix: "z",
  alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}),
    ms = M({
  name: "base58flickr",
  prefix: "Z",
  alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
var Es = Object.freeze({
  __proto__: null,
  base58btc: bs,
  base58flickr: ms
});
var fs = p({
  prefix: "m",
  name: "base64",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
  bitsPerChar: 6
}),
    ws = p({
  prefix: "M",
  name: "base64pad",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  bitsPerChar: 6
}),
    vs = p({
  prefix: "u",
  name: "base64url",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
  bitsPerChar: 6
}),
    Is = p({
  prefix: "U",
  name: "base64urlpad",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
  bitsPerChar: 6
});
var Cs = Object.freeze({
  __proto__: null,
  base64: fs,
  base64pad: ws,
  base64url: vs,
  base64urlpad: Is
});

var xe = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42"),
    _s = xe.reduce(function (r, e, t) {
  return r[t] = e, r;
}, []),
    Rs = xe.reduce(function (r, e, t) {
  return r[e.codePointAt(0)] = t, r;
}, []);

function Ts(r) {
  return r.reduce(function (e, t) {
    return e += _s[t], e;
  }, "");
}

function Ss(r) {
  var e = [];

  var _iterator = _createForOfIteratorHelper(r),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var t = _step.value;
      var i = Rs[t.codePointAt(0)];
      if (i === void 0) throw new Error("Non-base256emoji character: ".concat(t));
      e.push(i);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return new Uint8Array(e);
}

var Ps = G({
  prefix: "\uD83D\uDE80",
  name: "base256emoji",
  encode: Ts,
  decode: Ss
});
var Os = Object.freeze({
  __proto__: null,
  base256emoji: Ps
}),
    xs = ze,
    Ae = 128,
    As = 127,
    zs = ~As,
    Ns = Math.pow(2, 31);

function ze(r, e, t) {
  e = e || [], t = t || 0;

  for (var i = t; r >= Ns;) {
    e[t++] = r & 255 | Ae, r /= 128;
  }

  for (; r & zs;) {
    e[t++] = r & 255 | Ae, r >>>= 7;
  }

  return e[t] = r | 0, ze.bytes = t - i + 1, e;
}

var Us = ae,
    Ls = 128,
    Ne = 127;

function ae(r, i) {
  var t = 0,
      i = i || 0,
      s = 0,
      n = i,
      a,
      o = r.length;

  do {
    if (n >= o) throw ae.bytes = 0, new RangeError("Could not decode varint");
    a = r[n++], t += s < 28 ? (a & Ne) << s : (a & Ne) * Math.pow(2, s), s += 7;
  } while (a >= Ls);

  return ae.bytes = n - i, t;
}

var Fs = Math.pow(2, 7),
    $s = Math.pow(2, 14),
    Ms = Math.pow(2, 21),
    Ks = Math.pow(2, 28),
    ks = Math.pow(2, 35),
    Bs = Math.pow(2, 42),
    js = Math.pow(2, 49),
    Vs = Math.pow(2, 56),
    qs = Math.pow(2, 63),
    Gs = function Gs(r) {
  return r < Fs ? 1 : r < $s ? 2 : r < Ms ? 3 : r < Ks ? 4 : r < ks ? 5 : r < Bs ? 6 : r < js ? 7 : r < Vs ? 8 : r < qs ? 9 : 10;
},
    Ys = {
  encode: xs,
  decode: Us,
  encodingLength: Gs
},
    Ue = Ys;

var Le = function Le(r, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return Ue.encode(r, e, t), e;
},
    Fe = function Fe(r) {
  return Ue.encodingLength(r);
},
    oe = function oe(r, e) {
  var t = e.byteLength,
      i = Fe(r),
      s = i + Fe(t),
      n = new Uint8Array(s + t);
  return Le(r, n, 0), Le(t, n, i), n.set(e, s), new Js(r, t, e, n);
};

var Js = /*#__PURE__*/_createClass(function Js(e, t, i, s) {
  _classCallCheck(this, Js);

  this.code = e, this.size = t, this.digest = i, this.bytes = s;
});

var $e = function $e(_ref6) {
  var r = _ref6.name,
      e = _ref6.code,
      t = _ref6.encode;
  return new Hs(r, e, t);
};

var Hs = /*#__PURE__*/function () {
  function Hs(e, t, i) {
    _classCallCheck(this, Hs);

    this.name = e, this.code = t, this.encode = i;
  }

  _createClass(Hs, [{
    key: "digest",
    value: function digest(e) {
      var _this = this;

      if (e instanceof Uint8Array) {
        var t = this.encode(e);
        return t instanceof Uint8Array ? oe(this.code, t) : t.then(function (i) {
          return oe(_this.code, i);
        });
      } else throw Error("Unknown type, must be binary type");
    }
  }]);

  return Hs;
}();

var Me = function Me(r) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(e) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = Uint8Array;
              _context.next = 3;
              return crypto.subtle.digest(r, e);

            case 3:
              _context.t1 = _context.sent;
              return _context.abrupt("return", new _context.t0(_context.t1));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref7.apply(this, arguments);
    };
  }();
},
    Ws = $e({
  name: "sha2-256",
  code: 18,
  encode: Me("SHA-256")
}),
    Xs = $e({
  name: "sha2-512",
  code: 19,
  encode: Me("SHA-512")
});

var Zs = Object.freeze({
  __proto__: null,
  sha256: Ws,
  sha512: Xs
});

var Ke = 0,
    Qs = "identity",
    ke = Pe,
    er = function er(r) {
  return oe(Ke, ke(r));
},
    tr = {
  code: Ke,
  name: Qs,
  encode: ke,
  digest: er
};

var ir = Object.freeze({
  __proto__: null,
  identity: tr
});
new TextEncoder(), new TextDecoder();

var Be = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, Ji), Wi), Zi), es), ss), gs), ys), Es), Cs), Os);

_objectSpread(_objectSpread({}, Zs), ir);

function je(r) {
  return globalThis.Buffer != null ? new Uint8Array(r.buffer, r.byteOffset, r.byteLength) : r;
}

function sr() {
  var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? je(globalThis.Buffer.allocUnsafe(r)) : new Uint8Array(r);
}

function Ve(r, e, t, i) {
  return {
    name: r,
    prefix: e,
    encoder: {
      name: r,
      prefix: e,
      encode: t
    },
    decoder: {
      decode: i
    }
  };
}

var qe = Ve("utf8", "u", function (r) {
  return "u" + new TextDecoder("utf8").decode(r);
}, function (r) {
  return new TextEncoder().encode(r.substring(1));
}),
    he = Ve("ascii", "a", function (r) {
  var e = "a";

  for (var t = 0; t < r.length; t++) {
    e += String.fromCharCode(r[t]);
  }

  return e;
}, function (r) {
  r = r.substring(1);
  var e = sr(r.length);

  for (var t = 0; t < r.length; t++) {
    e[t] = r.charCodeAt(t);
  }

  return e;
}),
    rr = _objectSpread({
  utf8: qe,
  "utf-8": qe,
  hex: Be.base16,
  latin1: he,
  ascii: he,
  binary: he
}, Be);

function nr(r) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "utf8";
  var t = rr[e];
  if (!t) throw new Error("Unsupported encoding \"".concat(e, "\""));
  return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? je(globalThis.Buffer.from(r, "utf-8")) : t.decoder.decode("".concat(t.prefix).concat(r));
}

var ce = "wc",
    Ge = 2,
    Y = "core",
    O = "".concat(ce, "@2:").concat(Y, ":"),
    Ye = {
  name: Y,
  logger: "error"
},
    Je = {
  database: ":memory:"
},
    He = "crypto",
    ue = "client_ed25519_seed",
    We = _time.ONE_DAY,
    Xe = "keychain",
    Ze = "0.3",
    Qe = "messages",
    et = "0.3",
    tt = _time.SIX_HOURS,
    it = "publisher",
    st = "irn",
    rt = "error",
    le = "wss://relay.walletconnect.com",
    nt = "relayer",
    g = {
  message: "relayer_message",
  message_ack: "relayer_message_ack",
  connect: "relayer_connect",
  disconnect: "relayer_disconnect",
  error: "relayer_error",
  connection_stalled: "relayer_connection_stalled",
  transport_closed: "relayer_transport_closed",
  publish: "relayer_publish"
},
    at = "_subscription",
    L = {
  payload: "payload",
  connect: "connect",
  disconnect: "disconnect",
  error: "error"
},
    ot = _time.ONE_SECOND / 2,
    ar = {
  database: ":memory:"
},
    ht = "2.8.2",
    ct = 1e4,
    ut = "0.3",
    lt = "WALLETCONNECT_CLIENT_ID",
    C = {
  created: "subscription_created",
  deleted: "subscription_deleted",
  expired: "subscription_expired",
  disabled: "subscription_disabled",
  sync: "subscription_sync",
  resubscribed: "subscription_resubscribed"
},
    or = _time.THIRTY_DAYS,
    dt = "subscription",
    gt = "0.3",
    pt = _time.FIVE_SECONDS * 1e3,
    Dt = "pairing",
    yt = "0.3",
    hr = _time.THIRTY_DAYS,
    F = {
  wc_pairingDelete: {
    req: {
      ttl: _time.ONE_DAY,
      prompt: !1,
      tag: 1e3
    },
    res: {
      ttl: _time.ONE_DAY,
      prompt: !1,
      tag: 1001
    }
  },
  wc_pairingPing: {
    req: {
      ttl: _time.THIRTY_SECONDS,
      prompt: !1,
      tag: 1002
    },
    res: {
      ttl: _time.THIRTY_SECONDS,
      prompt: !1,
      tag: 1003
    }
  },
  unregistered_method: {
    req: {
      ttl: _time.ONE_DAY,
      prompt: !1,
      tag: 0
    },
    res: {
      ttl: _time.ONE_DAY,
      prompt: !1,
      tag: 0
    }
  }
},
    _ = {
  created: "history_created",
  updated: "history_updated",
  deleted: "history_deleted",
  sync: "history_sync"
},
    bt = "history",
    mt = "0.3",
    Et = "expirer",
    w = {
  created: "expirer_created",
  deleted: "expirer_deleted",
  expired: "expirer_expired",
  sync: "expirer_sync"
},
    ft = "0.3",
    cr = _time.ONE_DAY,
    J = "verify-api",
    de = "https://verify.walletconnect.com";
exports.VERIFY_SERVER = de;
exports.VERIFY_CONTEXT = J;
exports.EXPIRER_DEFAULT_TTL = cr;
exports.EXPIRER_STORAGE_VERSION = ft;
exports.EXPIRER_EVENTS = w;
exports.EXPIRER_CONTEXT = Et;
exports.HISTORY_STORAGE_VERSION = mt;
exports.HISTORY_CONTEXT = bt;
exports.HISTORY_EVENTS = _;
exports.PAIRING_RPC_OPTS = F;
exports.PAIRING_DEFAULT_TTL = hr;
exports.PAIRING_STORAGE_VERSION = yt;
exports.PAIRING_CONTEXT = Dt;
exports.PENDING_SUB_RESOLUTION_TIMEOUT = pt;
exports.SUBSCRIBER_STORAGE_VERSION = gt;
exports.SUBSCRIBER_CONTEXT = dt;
exports.SUBSCRIBER_DEFAULT_TTL = or;
exports.SUBSCRIBER_EVENTS = C;
exports.WALLETCONNECT_CLIENT_ID = lt;
exports.STORE_STORAGE_VERSION = ut;
exports.RELAYER_TRANSPORT_CUTOFF = ct;
exports.RELAYER_SDK_VERSION = ht;
exports.RELAYER_STORAGE_OPTIONS = ar;
exports.RELAYER_RECONNECT_TIMEOUT = ot;
exports.RELAYER_PROVIDER_EVENTS = L;
exports.RELAYER_SUBSCRIBER_SUFFIX = at;
exports.RELAYER_EVENTS = g;
exports.RELAYER_CONTEXT = nt;
exports.RELAYER_DEFAULT_RELAY_URL = le;
exports.RELAYER_DEFAULT_LOGGER = rt;
exports.RELAYER_DEFAULT_PROTOCOL = st;
exports.PUBLISHER_CONTEXT = it;
exports.PUBLISHER_DEFAULT_TTL = tt;
exports.MESSAGES_STORAGE_VERSION = et;
exports.MESSAGES_CONTEXT = Qe;
exports.KEYCHAIN_STORAGE_VERSION = Ze;
exports.KEYCHAIN_CONTEXT = Xe;
exports.CRYPTO_JWT_TTL = We;
exports.CRYPTO_CLIENT_SEED = ue;
exports.CRYPTO_CONTEXT = He;
exports.CORE_STORAGE_OPTIONS = Je;
exports.CORE_DEFAULT = Ye;
exports.CORE_STORAGE_PREFIX = O;
exports.CORE_CONTEXT = Y;
exports.CORE_VERSION = Ge;
exports.CORE_PROTOCOL = ce;

var wt = /*#__PURE__*/function () {
  function wt(e, t) {
    var _this2 = this;

    _classCallCheck(this, wt);

    this.core = e, this.logger = t, this.keychain = new Map(), this.name = Xe, this.version = Ze, this.initialized = !1, this.storagePrefix = O, this.init = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var i;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (_this2.initialized) {
                _context2.next = 5;
                break;
              }

              _context2.next = 3;
              return _this2.getKeyChain();

            case 3:
              i = _context2.sent;
              _typeof(i) < "u" && (_this2.keychain = i), _this2.initialized = !0;

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })), this.has = function (i) {
      return _this2.isInitialized(), _this2.keychain.has(i);
    }, this.set = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee3(i, s) {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.isInitialized();

                _this2.keychain.set(i, s);

                _context3.next = 4;
                return _this2.persist();

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x2, _x3) {
        return _ref9.apply(this, arguments);
      };
    }(), this.get = function (i) {
      _this2.isInitialized();

      var s = _this2.keychain.get(i);

      if (_typeof(s) > "u") {
        var _c = (0, _utils.getInternalError)("NO_MATCHING_KEY", "".concat(_this2.name, ": ").concat(i)),
            n = _c.message;

        throw new Error(n);
      }

      return s;
    }, this.del = /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee4(i) {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this2.isInitialized();

                _this2.keychain["delete"](i);

                _context4.next = 4;
                return _this2.persist();

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x4) {
        return _ref10.apply(this, arguments);
      };
    }(), this.core = e, this.logger = (0, _logger.generateChildLogger)(t, this.name);
  }

  _createClass(wt, [{
    key: "context",
    get: function get() {
      return (0, _logger.getLoggerContext)(this.logger);
    }
  }, {
    key: "storageKey",
    get: function get() {
      return this.storagePrefix + this.version + "//" + this.name;
    }
  }, {
    key: "setKeyChain",
    value: function () {
      var _setKeyChain = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee5(e) {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.core.storage.setItem(this.storageKey, (0, _utils.mapToObj)(e));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function setKeyChain(_x5) {
        return _setKeyChain.apply(this, arguments);
      }

      return setKeyChain;
    }()
  }, {
    key: "getKeyChain",
    value: function () {
      var _getKeyChain = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        var e;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.core.storage.getItem(this.storageKey);

              case 2:
                e = _context6.sent;
                return _context6.abrupt("return", _typeof(e) < "u" ? (0, _utils.objToMap)(e) : void 0);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getKeyChain() {
        return _getKeyChain.apply(this, arguments);
      }

      return getKeyChain;
    }()
  }, {
    key: "persist",
    value: function () {
      var _persist = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.setKeyChain(this.keychain);

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function persist() {
        return _persist.apply(this, arguments);
      }

      return persist;
    }()
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      if (!this.initialized) {
        var _c2 = (0, _utils.getInternalError)("NOT_INITIALIZED", this.name),
            e = _c2.message;

        throw new Error(e);
      }
    }
  }]);

  return wt;
}();

exports.KeyChain = wt;

var vt = /*#__PURE__*/function () {
  function vt(e, t, i) {
    var _this3 = this;

    _classCallCheck(this, vt);

    this.core = e, this.logger = t, this.name = He, this.initialized = !1, this.init = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
      return _regenerator["default"].wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.t0 = _this3.initialized;

              if (_context8.t0) {
                _context8.next = 5;
                break;
              }

              _context8.next = 4;
              return _this3.keychain.init();

            case 4:
              _this3.initialized = !0;

            case 5:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    })), this.hasKeys = function (s) {
      return _this3.isInitialized(), _this3.keychain.has(s);
    }, this.getClientId = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
      var s, n;
      return _regenerator["default"].wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _this3.isInitialized();

              _context9.next = 3;
              return _this3.getClientSeed();

            case 3:
              s = _context9.sent;
              n = j.generateKeyPair(s);
              return _context9.abrupt("return", j.encodeIss(n.publicKey));

            case 6:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    })), this.generateKeyPair = function () {
      _this3.isInitialized();

      var s = (0, _utils.generateKeyPair)();
      return _this3.setPrivateKey(s.publicKey, s.privateKey);
    }, this.signJWT = /*#__PURE__*/function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee10(s) {
        var n, a, o, h;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this3.isInitialized();

                _context10.next = 3;
                return _this3.getClientSeed();

              case 3:
                n = _context10.sent;
                a = j.generateKeyPair(n);
                o = (0, _utils.generateRandomBytes32)();
                h = We;
                _context10.next = 9;
                return j.signJWT(o, s, h, a);

              case 9:
                return _context10.abrupt("return", _context10.sent);

              case 10:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      return function (_x6) {
        return _ref13.apply(this, arguments);
      };
    }(), this.generateSharedKey = function (s, n, a) {
      _this3.isInitialized();

      var o = _this3.getPrivateKey(s),
          h = (0, _utils.deriveSymKey)(o, n);

      return _this3.setSymKey(h, a);
    }, this.setSymKey = /*#__PURE__*/function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee11(s, n) {
        var a;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this3.isInitialized();

                a = n || (0, _utils.hashKey)(s);
                _context11.next = 4;
                return _this3.keychain.set(a, s);

              case 4:
                return _context11.abrupt("return", a);

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      return function (_x7, _x8) {
        return _ref14.apply(this, arguments);
      };
    }(), this.deleteKeyPair = /*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee12(s) {
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _this3.isInitialized();

                _context12.next = 3;
                return _this3.keychain.del(s);

              case 3:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      return function (_x9) {
        return _ref15.apply(this, arguments);
      };
    }(), this.deleteSymKey = /*#__PURE__*/function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee13(s) {
        return _regenerator["default"].wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _this3.isInitialized();

                _context13.next = 3;
                return _this3.keychain.del(s);

              case 3:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      return function (_x10) {
        return _ref16.apply(this, arguments);
      };
    }(), this.encode = /*#__PURE__*/function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee14(s, n, a) {
        var o, h, b, k, d, l, D;
        return _regenerator["default"].wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _this3.isInitialized();

                o = (0, _utils.validateEncoding)(a), h = (0, _safeJson.safeJsonStringify)(n);

                if (!(0, _utils.isTypeOneEnvelope)(o)) {
                  _context14.next = 7;
                  break;
                }

                b = o.senderPublicKey, k = o.receiverPublicKey;
                _context14.next = 6;
                return _this3.generateSharedKey(b, k);

              case 6:
                s = _context14.sent;

              case 7:
                d = _this3.getSymKey(s), l = o.type, D = o.senderPublicKey;
                return _context14.abrupt("return", (0, _utils.encrypt)({
                  type: l,
                  symKey: d,
                  message: h,
                  senderPublicKey: D
                }));

              case 9:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      return function (_x11, _x12, _x13) {
        return _ref17.apply(this, arguments);
      };
    }(), this.decode = /*#__PURE__*/function () {
      var _ref18 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee15(s, n, a) {
        var o, l, D, h, d;
        return _regenerator["default"].wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _this3.isInitialized();

                o = (0, _utils.validateDecoding)(n, a);

                if (!(0, _utils.isTypeOneEnvelope)(o)) {
                  _context15.next = 7;
                  break;
                }

                l = o.receiverPublicKey, D = o.senderPublicKey;
                _context15.next = 6;
                return _this3.generateSharedKey(l, D);

              case 6:
                s = _context15.sent;

              case 7:
                h = _this3.getSymKey(s), d = (0, _utils.decrypt)({
                  symKey: h,
                  encoded: n
                });
                return _context15.abrupt("return", (0, _safeJson.safeJsonParse)(d));

              case 9:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      return function (_x14, _x15, _x16) {
        return _ref18.apply(this, arguments);
      };
    }(), this.getPayloadType = function (s) {
      var n = (0, _utils.deserialize)(s);
      return (0, _utils.decodeTypeByte)(n.type);
    }, this.getPayloadSenderPublicKey = function (s) {
      var n = (0, _utils.deserialize)(s);
      return n.senderPublicKey ? (0, _uint8arrays.toString)(n.senderPublicKey, _utils.BASE16) : void 0;
    }, this.core = e, this.logger = (0, _logger.generateChildLogger)(t, this.name), this.keychain = i || new wt(this.core, this.logger);
  }

  _createClass(vt, [{
    key: "context",
    get: function get() {
      return (0, _logger.getLoggerContext)(this.logger);
    }
  }, {
    key: "setPrivateKey",
    value: function () {
      var _setPrivateKey = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee16(e, t) {
        return _regenerator["default"].wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.keychain.set(e, t);

              case 2:
                return _context16.abrupt("return", e);

              case 3:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function setPrivateKey(_x17, _x18) {
        return _setPrivateKey.apply(this, arguments);
      }

      return setPrivateKey;
    }()
  }, {
    key: "getPrivateKey",
    value: function getPrivateKey(e) {
      return this.keychain.get(e);
    }
  }, {
    key: "getClientSeed",
    value: function () {
      var _getClientSeed = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee17() {
        var e;
        return _regenerator["default"].wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                e = "";
                _context17.prev = 1;
                e = this.keychain.get(ue);
                _context17.next = 10;
                break;

              case 5:
                _context17.prev = 5;
                _context17.t0 = _context17["catch"](1);
                e = (0, _utils.generateRandomBytes32)();
                _context17.next = 10;
                return this.keychain.set(ue, e);

              case 10:
                return _context17.abrupt("return", nr(e, "base16"));

              case 11:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this, [[1, 5]]);
      }));

      function getClientSeed() {
        return _getClientSeed.apply(this, arguments);
      }

      return getClientSeed;
    }()
  }, {
    key: "getSymKey",
    value: function getSymKey(e) {
      return this.keychain.get(e);
    }
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      if (!this.initialized) {
        var _c3 = (0, _utils.getInternalError)("NOT_INITIALIZED", this.name),
            e = _c3.message;

        throw new Error(e);
      }
    }
  }]);

  return vt;
}();

exports.Crypto = vt;

var It = /*#__PURE__*/function (_Vt) {
  _inherits(It, _Vt);

  var _super = _createSuper(It);

  function It(e, t) {
    var _this4;

    _classCallCheck(this, It);

    _this4 = _super.call(this, e, t), _this4.logger = e, _this4.core = t, _this4.messages = new Map(), _this4.name = Qe, _this4.version = et, _this4.initialized = !1, _this4.storagePrefix = O, _this4.init = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee18() {
      var i;
      return _regenerator["default"].wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              if (_this4.initialized) {
                _context18.next = 15;
                break;
              }

              _this4.logger.trace("Initialized");

              _context18.prev = 2;
              _context18.next = 5;
              return _this4.getRelayerMessages();

            case 5:
              i = _context18.sent;
              _typeof(i) < "u" && (_this4.messages = i), _this4.logger.debug("Successfully Restored records for ".concat(_this4.name)), _this4.logger.trace({
                type: "method",
                method: "restore",
                size: _this4.messages.size
              });
              _context18.next = 12;
              break;

            case 9:
              _context18.prev = 9;
              _context18.t0 = _context18["catch"](2);
              _this4.logger.debug("Failed to Restore records for ".concat(_this4.name)), _this4.logger.error(_context18.t0);

            case 12:
              _context18.prev = 12;
              _this4.initialized = !0;
              return _context18.finish(12);

            case 15:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18, null, [[2, 9, 12, 15]]);
    })), _this4.set = /*#__PURE__*/function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee19(i, s) {
        var n, a;
        return _regenerator["default"].wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _this4.isInitialized();

                n = (0, _utils.hashMessage)(s);
                a = _this4.messages.get(i);
                _typeof(a) > "u" && (a = {});
                _context19.t0 = _typeof(a[n]) < "u";

                if (_context19.t0) {
                  _context19.next = 10;
                  break;
                }

                a[n] = s;

                _this4.messages.set(i, a);

                _context19.next = 10;
                return _this4.persist();

              case 10:
                return _context19.abrupt("return", n);

              case 11:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19);
      }));

      return function (_x19, _x20) {
        return _ref20.apply(this, arguments);
      };
    }(), _this4.get = function (i) {
      _this4.isInitialized();

      var s = _this4.messages.get(i);

      return _typeof(s) > "u" && (s = {}), s;
    }, _this4.has = function (i, s) {
      _this4.isInitialized();

      var n = _this4.get(i),
          a = (0, _utils.hashMessage)(s);

      return _typeof(n[a]) < "u";
    }, _this4.del = /*#__PURE__*/function () {
      var _ref21 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee20(i) {
        return _regenerator["default"].wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _this4.isInitialized();

                _this4.messages["delete"](i);

                _context20.next = 4;
                return _this4.persist();

              case 4:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }));

      return function (_x21) {
        return _ref21.apply(this, arguments);
      };
    }(), _this4.logger = (0, _logger.generateChildLogger)(e, _this4.name), _this4.core = t;
    return _this4;
  }

  _createClass(It, [{
    key: "context",
    get: function get() {
      return (0, _logger.getLoggerContext)(this.logger);
    }
  }, {
    key: "storageKey",
    get: function get() {
      return this.storagePrefix + this.version + "//" + this.name;
    }
  }, {
    key: "setRelayerMessages",
    value: function () {
      var _setRelayerMessages = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee21(e) {
        return _regenerator["default"].wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return this.core.storage.setItem(this.storageKey, (0, _utils.mapToObj)(e));

              case 2:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function setRelayerMessages(_x22) {
        return _setRelayerMessages.apply(this, arguments);
      }

      return setRelayerMessages;
    }()
  }, {
    key: "getRelayerMessages",
    value: function () {
      var _getRelayerMessages = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee22() {
        var e;
        return _regenerator["default"].wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return this.core.storage.getItem(this.storageKey);

              case 2:
                e = _context22.sent;
                return _context22.abrupt("return", _typeof(e) < "u" ? (0, _utils.objToMap)(e) : void 0);

              case 4:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function getRelayerMessages() {
        return _getRelayerMessages.apply(this, arguments);
      }

      return getRelayerMessages;
    }()
  }, {
    key: "persist",
    value: function () {
      var _persist2 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee23() {
        return _regenerator["default"].wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.next = 2;
                return this.setRelayerMessages(this.messages);

              case 2:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function persist() {
        return _persist2.apply(this, arguments);
      }

      return persist;
    }()
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      if (!this.initialized) {
        var _c4 = (0, _utils.getInternalError)("NOT_INITIALIZED", this.name),
            e = _c4.message;

        throw new Error(e);
      }
    }
  }]);

  return It;
}(_types.IMessageTracker);

exports.MessageTracker = It;

var ur = /*#__PURE__*/function (_qt) {
  _inherits(ur, _qt);

  var _super2 = _createSuper(ur);

  function ur(e, t) {
    var _this5;

    _classCallCheck(this, ur);

    _this5 = _super2.call(this, e, t), _this5.relayer = e, _this5.logger = t, _this5.events = new _events.EventEmitter(), _this5.name = it, _this5.queue = new Map(), _this5.publishTimeout = (0, _time.toMiliseconds)(_time.TEN_SECONDS), _this5.queueTimeout = (0, _time.toMiliseconds)(_time.FIVE_SECONDS), _this5.needsTransportRestart = !1, _this5.publish = /*#__PURE__*/function () {
      var _ref22 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee24(i, s, n) {
        var a, o, h, d, l, D, b;
        return _regenerator["default"].wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _this5.logger.debug("Publishing Payload"), _this5.logger.trace({
                  type: "method",
                  method: "publish",
                  params: {
                    topic: i,
                    message: s,
                    opts: n
                  }
                });
                _context24.prev = 1;
                a = (n === null || n === void 0 ? void 0 : n.ttl) || tt, o = (0, _utils.getRelayProtocolName)(n), h = (n === null || n === void 0 ? void 0 : n.prompt) || !1, d = (n === null || n === void 0 ? void 0 : n.tag) || 0, l = (n === null || n === void 0 ? void 0 : n.id) || (0, _jsonrpcUtils.getBigIntRpcId)().toString(), D = {
                  topic: i,
                  message: s,
                  opts: {
                    ttl: a,
                    relay: o,
                    prompt: h,
                    tag: d,
                    id: l
                  }
                }, b = setTimeout(function () {
                  return _this5.queue.set(l, D);
                }, _this5.queueTimeout);
                _context24.prev = 3;
                _context24.next = 6;
                return (0, _utils.createExpiringPromise)(_this5.rpcPublish(i, s, a, o, h, d, l), _this5.publishTimeout);

              case 6:
                _context24.next = 8;
                return _context24.sent;

              case 8:
                clearTimeout(b);

                _this5.relayer.events.emit(g.publish, D);

                _context24.next = 16;
                break;

              case 12:
                _context24.prev = 12;
                _context24.t0 = _context24["catch"](3);
                _this5.logger.debug("Publishing Payload stalled"), _this5.needsTransportRestart = !0;
                return _context24.abrupt("return");

              case 16:
                _this5.logger.debug("Successfully Published Payload"), _this5.logger.trace({
                  type: "method",
                  method: "publish",
                  params: {
                    topic: i,
                    message: s,
                    opts: n
                  }
                });
                _context24.next = 22;
                break;

              case 19:
                _context24.prev = 19;
                _context24.t1 = _context24["catch"](1);
                throw _this5.logger.debug("Failed to Publish Payload"), _this5.logger.error(_context24.t1), _context24.t1;

              case 22:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, null, [[1, 19], [3, 12]]);
      }));

      return function (_x23, _x24, _x25) {
        return _ref22.apply(this, arguments);
      };
    }(), _this5.on = function (i, s) {
      _this5.events.on(i, s);
    }, _this5.once = function (i, s) {
      _this5.events.once(i, s);
    }, _this5.off = function (i, s) {
      _this5.events.off(i, s);
    }, _this5.removeListener = function (i, s) {
      _this5.events.removeListener(i, s);
    }, _this5.relayer = e, _this5.logger = (0, _logger.generateChildLogger)(t, _this5.name), _this5.registerEventListeners();
    return _this5;
  }

  _createClass(ur, [{
    key: "context",
    get: function get() {
      return (0, _logger.getLoggerContext)(this.logger);
    }
  }, {
    key: "rpcPublish",
    value: function rpcPublish(e, t, i, s, n, a, o) {
      var h, d, l, D;
      var b = {
        method: (0, _utils.getRelayProtocolApi)(s.protocol).publish,
        params: {
          topic: e,
          message: t,
          ttl: i,
          prompt: n,
          tag: a
        },
        id: o
      };
      return (0, _utils.isUndefined)((h = b.params) == null ? void 0 : h.prompt) && ((d = b.params) == null || delete d.prompt), (0, _utils.isUndefined)((l = b.params) == null ? void 0 : l.tag) && ((D = b.params) == null || delete D.tag), this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
        type: "message",
        direction: "outgoing",
        request: b
      }), this.relayer.request(b);
    }
  }, {
    key: "onPublish",
    value: function onPublish(e) {
      this.queue["delete"](e);
    }
  }, {
    key: "checkQueue",
    value: function checkQueue() {
      var _this6 = this;

      this.queue.forEach( /*#__PURE__*/function () {
        var _ref23 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee25(e) {
          var t, i, s;
          return _regenerator["default"].wrap(function _callee25$(_context25) {
            while (1) {
              switch (_context25.prev = _context25.next) {
                case 0:
                  t = e.topic, i = e.message, s = e.opts;
                  _context25.next = 3;
                  return _this6.publish(t, i, s);

                case 3:
                case "end":
                  return _context25.stop();
              }
            }
          }, _callee25);
        }));

        return function (_x26) {
          return _ref23.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "registerEventListeners",
    value: function registerEventListeners() {
      var _this7 = this;

      this.relayer.core.heartbeat.on(_heartbeat.HEARTBEAT_EVENTS.pulse, function () {
        if (_this7.needsTransportRestart) {
          _this7.needsTransportRestart = !1, _this7.relayer.events.emit(g.connection_stalled);
          return;
        }

        _this7.checkQueue();
      }), this.relayer.on(g.message_ack, function (e) {
        _this7.onPublish(e.id.toString());
      });
    }
  }]);

  return ur;
}(_types.IPublisher);

var lr = /*#__PURE__*/function () {
  function lr() {
    var _this8 = this;

    _classCallCheck(this, lr);

    this.map = new Map(), this.set = function (e, t) {
      var i = _this8.get(e);

      _this8.exists(e, t) || _this8.map.set(e, [].concat(_toConsumableArray(i), [t]));
    }, this.get = function (e) {
      return _this8.map.get(e) || [];
    }, this.exists = function (e, t) {
      return _this8.get(e).includes(t);
    }, this["delete"] = function (e, t) {
      if (_typeof(t) > "u") {
        _this8.map["delete"](e);

        return;
      }

      if (!_this8.map.has(e)) return;

      var i = _this8.get(e);

      if (!_this8.exists(e, t)) return;
      var s = i.filter(function (n) {
        return n !== t;
      });

      if (!s.length) {
        _this8.map["delete"](e);

        return;
      }

      _this8.map.set(e, s);
    }, this.clear = function () {
      _this8.map.clear();
    };
  }

  _createClass(lr, [{
    key: "topics",
    get: function get() {
      return Array.from(this.map.keys());
    }
  }]);

  return lr;
}();

var dr = Object.defineProperty,
    gr = Object.defineProperties,
    pr = Object.getOwnPropertyDescriptors,
    Ct = Object.getOwnPropertySymbols,
    Dr = Object.prototype.hasOwnProperty,
    yr = Object.prototype.propertyIsEnumerable,
    _t = function _t(r, e, t) {
  return e in r ? dr(r, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : r[e] = t;
},
    K = function K(r, e) {
  for (var t in e || (e = {})) {
    Dr.call(e, t) && _t(r, t, e[t]);
  }

  if (Ct) {
    var _iterator2 = _createForOfIteratorHelper(Ct(e)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var t = _step2.value;
        yr.call(e, t) && _t(r, t, e[t]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return r;
},
    ge = function ge(r, e) {
  return gr(r, pr(e));
};

var Rt = /*#__PURE__*/function (_Gt) {
  _inherits(Rt, _Gt);

  var _super3 = _createSuper(Rt);

  function Rt(e, t) {
    var _this9;

    _classCallCheck(this, Rt);

    _this9 = _super3.call(this, e, t), _this9.relayer = e, _this9.logger = t, _this9.subscriptions = new Map(), _this9.topicMap = new lr(), _this9.events = new _events.EventEmitter(), _this9.name = dt, _this9.version = gt, _this9.pending = new Map(), _this9.cached = [], _this9.initialized = !1, _this9.pendingSubscriptionWatchLabel = "pending_sub_watch_label", _this9.pollingInterval = 20, _this9.storagePrefix = O, _this9.subscribeTimeout = 1e4, _this9.restartInProgress = !1, _this9.batchSubscribeTopicsLimit = 500, _this9.init = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee26() {
      return _regenerator["default"].wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              _context26.t0 = _this9.initialized;

              if (_context26.t0) {
                _context26.next = 10;
                break;
              }

              _this9.logger.trace("Initialized");

              _context26.next = 5;
              return _this9.restart();

            case 5:
              _this9.registerEventListeners();

              _this9.onEnable();

              _context26.next = 9;
              return _this9.relayer.core.crypto.getClientId();

            case 9:
              _this9.clientId = _context26.sent;

            case 10:
            case "end":
              return _context26.stop();
          }
        }
      }, _callee26);
    })), _this9.subscribe = /*#__PURE__*/function () {
      var _ref25 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee27(i, s) {
        var n, a, o;
        return _regenerator["default"].wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.next = 2;
                return _this9.restartToComplete();

              case 2:
                _this9.isInitialized();

                _this9.logger.debug("Subscribing Topic");

                _this9.logger.trace({
                  type: "method",
                  method: "subscribe",
                  params: {
                    topic: i,
                    opts: s
                  }
                });

                _context27.prev = 5;
                n = (0, _utils.getRelayProtocolName)(s), a = {
                  topic: i,
                  relay: n
                };

                _this9.pending.set(i, a);

                _context27.next = 10;
                return _this9.rpcSubscribe(i, n);

              case 10:
                o = _context27.sent;
                return _context27.abrupt("return", (_this9.onSubscribe(o, a), _this9.logger.debug("Successfully Subscribed Topic"), _this9.logger.trace({
                  type: "method",
                  method: "subscribe",
                  params: {
                    topic: i,
                    opts: s
                  }
                }), o));

              case 14:
                _context27.prev = 14;
                _context27.t0 = _context27["catch"](5);
                throw _this9.logger.debug("Failed to Subscribe Topic"), _this9.logger.error(_context27.t0), _context27.t0;

              case 17:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, null, [[5, 14]]);
      }));

      return function (_x27, _x28) {
        return _ref25.apply(this, arguments);
      };
    }(), _this9.unsubscribe = /*#__PURE__*/function () {
      var _ref26 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee28(i, s) {
        return _regenerator["default"].wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.next = 2;
                return _this9.restartToComplete();

              case 2:
                _this9.isInitialized();

                if (!(_typeof(s === null || s === void 0 ? void 0 : s.id) < "u")) {
                  _context28.next = 8;
                  break;
                }

                _context28.next = 6;
                return _this9.unsubscribeById(i, s.id, s);

              case 6:
                _context28.next = 10;
                break;

              case 8:
                _context28.next = 10;
                return _this9.unsubscribeByTopic(i, s);

              case 10:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28);
      }));

      return function (_x29, _x30) {
        return _ref26.apply(this, arguments);
      };
    }(), _this9.isSubscribed = /*#__PURE__*/function () {
      var _ref27 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee29(i) {
        return _regenerator["default"].wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                if (!_this9.topics.includes(i)) {
                  _context29.next = 4;
                  break;
                }

                _context29.t0 = !0;
                _context29.next = 7;
                break;

              case 4:
                _context29.next = 6;
                return new Promise(function (s, n) {
                  var a = new _time.Watch();
                  a.start(_this9.pendingSubscriptionWatchLabel);
                  var o = setInterval(function () {
                    !_this9.pending.has(i) && _this9.topics.includes(i) && (clearInterval(o), a.stop(_this9.pendingSubscriptionWatchLabel), s(!0)), a.elapsed(_this9.pendingSubscriptionWatchLabel) >= pt && (clearInterval(o), a.stop(_this9.pendingSubscriptionWatchLabel), n(new Error("Subscription resolution timeout")));
                  }, _this9.pollingInterval);
                })["catch"](function () {
                  return !1;
                });

              case 6:
                _context29.t0 = _context29.sent;

              case 7:
                return _context29.abrupt("return", _context29.t0);

              case 8:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29);
      }));

      return function (_x31) {
        return _ref27.apply(this, arguments);
      };
    }(), _this9.on = function (i, s) {
      _this9.events.on(i, s);
    }, _this9.once = function (i, s) {
      _this9.events.once(i, s);
    }, _this9.off = function (i, s) {
      _this9.events.off(i, s);
    }, _this9.removeListener = function (i, s) {
      _this9.events.removeListener(i, s);
    }, _this9.restart = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee30() {
      return _regenerator["default"].wrap(function _callee30$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              _this9.restartInProgress = !0;
              _context30.next = 3;
              return _this9.restore();

            case 3:
              _context30.next = 5;
              return _this9.reset();

            case 5:
              _this9.restartInProgress = !1;

            case 6:
            case "end":
              return _context30.stop();
          }
        }
      }, _callee30);
    })), _this9.relayer = e, _this9.logger = (0, _logger.generateChildLogger)(t, _this9.name), _this9.clientId = "";
    return _this9;
  }

  _createClass(Rt, [{
    key: "context",
    get: function get() {
      return (0, _logger.getLoggerContext)(this.logger);
    }
  }, {
    key: "storageKey",
    get: function get() {
      return this.storagePrefix + this.version + "//" + this.name;
    }
  }, {
    key: "length",
    get: function get() {
      return this.subscriptions.size;
    }
  }, {
    key: "ids",
    get: function get() {
      return Array.from(this.subscriptions.keys());
    }
  }, {
    key: "values",
    get: function get() {
      return Array.from(this.subscriptions.values());
    }
  }, {
    key: "topics",
    get: function get() {
      return this.topicMap.topics;
    }
  }, {
    key: "hasSubscription",
    value: function hasSubscription(e, t) {
      var i = !1;

      try {
        i = this.getSubscription(e).topic === t;
      } catch (_unused3) {}

      return i;
    }
  }, {
    key: "onEnable",
    value: function onEnable() {
      this.cached = [], this.initialized = !0;
    }
  }, {
    key: "onDisable",
    value: function onDisable() {
      this.cached = this.values, this.subscriptions.clear(), this.topicMap.clear();
    }
  }, {
    key: "unsubscribeByTopic",
    value: function () {
      var _unsubscribeByTopic = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee32(e, t) {
        var _this10 = this;

        var i;
        return _regenerator["default"].wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                i = this.topicMap.get(e);
                _context32.next = 3;
                return Promise.all(i.map( /*#__PURE__*/function () {
                  var _ref29 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee31(s) {
                    return _regenerator["default"].wrap(function _callee31$(_context31) {
                      while (1) {
                        switch (_context31.prev = _context31.next) {
                          case 0:
                            _context31.next = 2;
                            return _this10.unsubscribeById(e, s, t);

                          case 2:
                            return _context31.abrupt("return", _context31.sent);

                          case 3:
                          case "end":
                            return _context31.stop();
                        }
                      }
                    }, _callee31);
                  }));

                  return function (_x34) {
                    return _ref29.apply(this, arguments);
                  };
                }()));

              case 3:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function unsubscribeByTopic(_x32, _x33) {
        return _unsubscribeByTopic.apply(this, arguments);
      }

      return unsubscribeByTopic;
    }()
  }, {
    key: "unsubscribeById",
    value: function () {
      var _unsubscribeById = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee33(e, t, i) {
        var s, n;
        return _regenerator["default"].wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                this.logger.debug("Unsubscribing Topic"), this.logger.trace({
                  type: "method",
                  method: "unsubscribe",
                  params: {
                    topic: e,
                    id: t,
                    opts: i
                  }
                });
                _context33.prev = 1;
                s = (0, _utils.getRelayProtocolName)(i);
                _context33.next = 5;
                return this.rpcUnsubscribe(e, t, s);

              case 5:
                n = (0, _utils.getSdkError)("USER_DISCONNECTED", "".concat(this.name, ", ").concat(e));
                _context33.next = 8;
                return this.onUnsubscribe(e, t, n);

              case 8:
                this.logger.debug("Successfully Unsubscribed Topic");
                this.logger.trace({
                  type: "method",
                  method: "unsubscribe",
                  params: {
                    topic: e,
                    id: t,
                    opts: i
                  }
                });
                _context33.next = 15;
                break;

              case 12:
                _context33.prev = 12;
                _context33.t0 = _context33["catch"](1);
                throw this.logger.debug("Failed to Unsubscribe Topic"), this.logger.error(_context33.t0), _context33.t0;

              case 15:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this, [[1, 12]]);
      }));

      function unsubscribeById(_x35, _x36, _x37) {
        return _unsubscribeById.apply(this, arguments);
      }

      return unsubscribeById;
    }()
  }, {
    key: "rpcSubscribe",
    value: function () {
      var _rpcSubscribe = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee34(e, t) {
        var i;
        return _regenerator["default"].wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                i = {
                  method: (0, _utils.getRelayProtocolApi)(t.protocol).subscribe,
                  params: {
                    topic: e
                  }
                };
                this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
                  type: "payload",
                  direction: "outgoing",
                  request: i
                });
                _context34.prev = 2;
                _context34.next = 5;
                return (0, _utils.createExpiringPromise)(this.relayer.request(i), this.subscribeTimeout);

              case 5:
                _context34.next = 7;
                return _context34.sent;

              case 7:
                _context34.next = 12;
                break;

              case 9:
                _context34.prev = 9;
                _context34.t0 = _context34["catch"](2);
                this.logger.debug("Outgoing Relay Subscribe Payload stalled"), this.relayer.events.emit(g.connection_stalled);

              case 12:
                return _context34.abrupt("return", (0, _utils.hashMessage)(e + this.clientId));

              case 13:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this, [[2, 9]]);
      }));

      function rpcSubscribe(_x38, _x39) {
        return _rpcSubscribe.apply(this, arguments);
      }

      return rpcSubscribe;
    }()
  }, {
    key: "rpcBatchSubscribe",
    value: function () {
      var _rpcBatchSubscribe = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee35(e) {
        var t, i;
        return _regenerator["default"].wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                if (e.length) {
                  _context35.next = 2;
                  break;
                }

                return _context35.abrupt("return");

              case 2:
                t = e[0].relay, i = {
                  method: (0, _utils.getRelayProtocolApi)(t.protocol).batchSubscribe,
                  params: {
                    topics: e.map(function (s) {
                      return s.topic;
                    })
                  }
                };
                this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
                  type: "payload",
                  direction: "outgoing",
                  request: i
                });
                _context35.prev = 4;
                _context35.next = 7;
                return (0, _utils.createExpiringPromise)(this.relayer.request(i), this.subscribeTimeout);

              case 7:
                _context35.next = 9;
                return _context35.sent;

              case 9:
                return _context35.abrupt("return", _context35.sent);

              case 12:
                _context35.prev = 12;
                _context35.t0 = _context35["catch"](4);
                this.logger.debug("Outgoing Relay Payload stalled"), this.relayer.events.emit(g.connection_stalled);

              case 15:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this, [[4, 12]]);
      }));

      function rpcBatchSubscribe(_x40) {
        return _rpcBatchSubscribe.apply(this, arguments);
      }

      return rpcBatchSubscribe;
    }()
  }, {
    key: "rpcUnsubscribe",
    value: function rpcUnsubscribe(e, t, i) {
      var s = {
        method: (0, _utils.getRelayProtocolApi)(i.protocol).unsubscribe,
        params: {
          topic: e,
          id: t
        }
      };
      return this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
        type: "payload",
        direction: "outgoing",
        request: s
      }), this.relayer.request(s);
    }
  }, {
    key: "onSubscribe",
    value: function onSubscribe(e, t) {
      this.setSubscription(e, ge(K({}, t), {
        id: e
      })), this.pending["delete"](t.topic);
    }
  }, {
    key: "onBatchSubscribe",
    value: function onBatchSubscribe(e) {
      var _this11 = this;

      e.length && e.forEach(function (t) {
        _this11.setSubscription(t.id, K({}, t)), _this11.pending["delete"](t.topic);
      });
    }
  }, {
    key: "onUnsubscribe",
    value: function () {
      var _onUnsubscribe = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee36(e, t, i) {
        return _regenerator["default"].wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                this.events.removeAllListeners(t);
                this.hasSubscription(t, e) && this.deleteSubscription(t, i);
                _context36.next = 4;
                return this.relayer.messages.del(e);

              case 4:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));

      function onUnsubscribe(_x41, _x42, _x43) {
        return _onUnsubscribe.apply(this, arguments);
      }

      return onUnsubscribe;
    }()
  }, {
    key: "setRelayerSubscriptions",
    value: function () {
      var _setRelayerSubscriptions = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee37(e) {
        return _regenerator["default"].wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                _context37.next = 2;
                return this.relayer.core.storage.setItem(this.storageKey, e);

              case 2:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));

      function setRelayerSubscriptions(_x44) {
        return _setRelayerSubscriptions.apply(this, arguments);
      }

      return setRelayerSubscriptions;
    }()
  }, {
    key: "getRelayerSubscriptions",
    value: function () {
      var _getRelayerSubscriptions = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee38() {
        return _regenerator["default"].wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                _context38.next = 2;
                return this.relayer.core.storage.getItem(this.storageKey);

              case 2:
                return _context38.abrupt("return", _context38.sent);

              case 3:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));

      function getRelayerSubscriptions() {
        return _getRelayerSubscriptions.apply(this, arguments);
      }

      return getRelayerSubscriptions;
    }()
  }, {
    key: "setSubscription",
    value: function setSubscription(e, t) {
      this.subscriptions.has(e) || (this.logger.debug("Setting subscription"), this.logger.trace({
        type: "method",
        method: "setSubscription",
        id: e,
        subscription: t
      }), this.addSubscription(e, t));
    }
  }, {
    key: "addSubscription",
    value: function addSubscription(e, t) {
      this.subscriptions.set(e, K({}, t)), this.topicMap.set(t.topic, e), this.events.emit(C.created, t);
    }
  }, {
    key: "getSubscription",
    value: function getSubscription(e) {
      this.logger.debug("Getting subscription"), this.logger.trace({
        type: "method",
        method: "getSubscription",
        id: e
      });
      var t = this.subscriptions.get(e);

      if (!t) {
        var _c5 = (0, _utils.getInternalError)("NO_MATCHING_KEY", "".concat(this.name, ": ").concat(e)),
            i = _c5.message;

        throw new Error(i);
      }

      return t;
    }
  }, {
    key: "deleteSubscription",
    value: function deleteSubscription(e, t) {
      this.logger.debug("Deleting subscription"), this.logger.trace({
        type: "method",
        method: "deleteSubscription",
        id: e,
        reason: t
      });
      var i = this.getSubscription(e);
      this.subscriptions["delete"](e), this.topicMap["delete"](i.topic, e), this.events.emit(C.deleted, ge(K({}, i), {
        reason: t
      }));
    }
  }, {
    key: "persist",
    value: function () {
      var _persist3 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee39() {
        return _regenerator["default"].wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                _context39.next = 2;
                return this.setRelayerSubscriptions(this.values);

              case 2:
                this.events.emit(C.sync);

              case 3:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));

      function persist() {
        return _persist3.apply(this, arguments);
      }

      return persist;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee40() {
        var e, t, i;
        return _regenerator["default"].wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                if (!this.cached.length) {
                  _context40.next = 10;
                  break;
                }

                e = Math.ceil(this.cached.length / this.batchSubscribeTopicsLimit);
                t = 0;

              case 3:
                if (!(t < e)) {
                  _context40.next = 10;
                  break;
                }

                i = this.cached.splice(0, this.batchSubscribeTopicsLimit);
                _context40.next = 7;
                return this.batchSubscribe(i);

              case 7:
                t++;
                _context40.next = 3;
                break;

              case 10:
                this.events.emit(C.resubscribed);

              case 11:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, this);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "restore",
    value: function () {
      var _restore = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee41() {
        var e, _c6, t;

        return _regenerator["default"].wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                _context41.prev = 0;
                _context41.next = 3;
                return this.getRelayerSubscriptions();

              case 3:
                e = _context41.sent;

                if (!(_typeof(e) > "u" || !e.length)) {
                  _context41.next = 6;
                  break;
                }

                return _context41.abrupt("return");

              case 6:
                if (!this.subscriptions.size) {
                  _context41.next = 9;
                  break;
                }

                _c6 = (0, _utils.getInternalError)("RESTORE_WILL_OVERRIDE", this.name), t = _c6.message;
                throw this.logger.error(t), this.logger.error("".concat(this.name, ": ").concat(JSON.stringify(this.values))), new Error(t);

              case 9:
                this.cached = e, this.logger.debug("Successfully Restored subscriptions for ".concat(this.name)), this.logger.trace({
                  type: "method",
                  method: "restore",
                  subscriptions: this.values
                });
                _context41.next = 15;
                break;

              case 12:
                _context41.prev = 12;
                _context41.t0 = _context41["catch"](0);
                this.logger.debug("Failed to Restore subscriptions for ".concat(this.name)), this.logger.error(_context41.t0);

              case 15:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this, [[0, 12]]);
      }));

      function restore() {
        return _restore.apply(this, arguments);
      }

      return restore;
    }()
  }, {
    key: "batchSubscribe",
    value: function () {
      var _batchSubscribe = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee42(e) {
        var t;
        return _regenerator["default"].wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                if (e.length) {
                  _context42.next = 2;
                  break;
                }

                return _context42.abrupt("return");

              case 2:
                _context42.next = 4;
                return this.rpcBatchSubscribe(e);

              case 4:
                t = _context42.sent;
                (0, _utils.isValidArray)(t) && this.onBatchSubscribe(t.map(function (i, s) {
                  return ge(K({}, e[s]), {
                    id: i
                  });
                }));

              case 6:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, this);
      }));

      function batchSubscribe(_x45) {
        return _batchSubscribe.apply(this, arguments);
      }

      return batchSubscribe;
    }()
  }, {
    key: "onConnect",
    value: function () {
      var _onConnect = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee43() {
        return _regenerator["default"].wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                _context43.t0 = this.restartInProgress;

                if (_context43.t0) {
                  _context43.next = 5;
                  break;
                }

                _context43.next = 4;
                return this.restart();

              case 4:
                this.onEnable();

              case 5:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43, this);
      }));

      function onConnect() {
        return _onConnect.apply(this, arguments);
      }

      return onConnect;
    }()
  }, {
    key: "onDisconnect",
    value: function onDisconnect() {
      this.onDisable();
    }
  }, {
    key: "checkPending",
    value: function () {
      var _checkPending = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee44() {
        var e;
        return _regenerator["default"].wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                if (!this.relayer.transportExplicitlyClosed) {
                  _context44.next = 2;
                  break;
                }

                return _context44.abrupt("return");

              case 2:
                e = [];
                this.pending.forEach(function (t) {
                  e.push(t);
                });
                _context44.next = 6;
                return this.batchSubscribe(e);

              case 6:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44, this);
      }));

      function checkPending() {
        return _checkPending.apply(this, arguments);
      }

      return checkPending;
    }()
  }, {
    key: "registerEventListeners",
    value: function registerEventListeners() {
      var _this12 = this;

      this.relayer.core.heartbeat.on(_heartbeat.HEARTBEAT_EVENTS.pulse, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee45() {
        return _regenerator["default"].wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                _context45.next = 2;
                return _this12.checkPending();

              case 2:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45);
      }))), this.relayer.on(g.connect, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee46() {
        return _regenerator["default"].wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                _context46.next = 2;
                return _this12.onConnect();

              case 2:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46);
      }))), this.relayer.on(g.disconnect, function () {
        _this12.onDisconnect();
      }), this.events.on(C.created, /*#__PURE__*/function () {
        var _ref32 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee47(e) {
          var t;
          return _regenerator["default"].wrap(function _callee47$(_context47) {
            while (1) {
              switch (_context47.prev = _context47.next) {
                case 0:
                  t = C.created;

                  _this12.logger.info("Emitting ".concat(t));

                  _this12.logger.debug({
                    type: "event",
                    event: t,
                    data: e
                  });

                  _context47.next = 5;
                  return _this12.persist();

                case 5:
                case "end":
                  return _context47.stop();
              }
            }
          }, _callee47);
        }));

        return function (_x46) {
          return _ref32.apply(this, arguments);
        };
      }()), this.events.on(C.deleted, /*#__PURE__*/function () {
        var _ref33 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee48(e) {
          var t;
          return _regenerator["default"].wrap(function _callee48$(_context48) {
            while (1) {
              switch (_context48.prev = _context48.next) {
                case 0:
                  t = C.deleted;

                  _this12.logger.info("Emitting ".concat(t));

                  _this12.logger.debug({
                    type: "event",
                    event: t,
                    data: e
                  });

                  _context48.next = 5;
                  return _this12.persist();

                case 5:
                case "end":
                  return _context48.stop();
              }
            }
          }, _callee48);
        }));

        return function (_x47) {
          return _ref33.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      if (!this.initialized) {
        var _c7 = (0, _utils.getInternalError)("NOT_INITIALIZED", this.name),
            e = _c7.message;

        throw new Error(e);
      }
    }
  }, {
    key: "restartToComplete",
    value: function () {
      var _restartToComplete = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee49() {
        var _this13 = this;

        return _regenerator["default"].wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                _context49.t0 = this.restartInProgress;

                if (!_context49.t0) {
                  _context49.next = 4;
                  break;
                }

                _context49.next = 4;
                return new Promise(function (e) {
                  var t = setInterval(function () {
                    _this13.restartInProgress || (clearInterval(t), e());
                  }, _this13.pollingInterval);
                });

              case 4:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this);
      }));

      function restartToComplete() {
        return _restartToComplete.apply(this, arguments);
      }

      return restartToComplete;
    }()
  }]);

  return Rt;
}(_types.ISubscriber);

exports.Subscriber = Rt;

var br = Object.defineProperty,
    Tt = Object.getOwnPropertySymbols,
    mr = Object.prototype.hasOwnProperty,
    Er = Object.prototype.propertyIsEnumerable,
    St = function St(r, e, t) {
  return e in r ? br(r, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : r[e] = t;
},
    fr = function fr(r, e) {
  for (var t in e || (e = {})) {
    mr.call(e, t) && St(r, t, e[t]);
  }

  if (Tt) {
    var _iterator3 = _createForOfIteratorHelper(Tt(e)),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var t = _step3.value;
        Er.call(e, t) && St(r, t, e[t]);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  return r;
};

var Pt = /*#__PURE__*/function (_Yt) {
  _inherits(Pt, _Yt);

  var _super4 = _createSuper(Pt);

  function Pt(e) {
    var _this14;

    _classCallCheck(this, Pt);

    _this14 = _super4.call(this, e), _this14.protocol = "wc", _this14.version = 2, _this14.events = new _events.EventEmitter(), _this14.name = nt, _this14.transportExplicitlyClosed = !1, _this14.initialized = !1, _this14.reconnecting = !1, _this14.connectionStatusPollingInterval = 20, _this14.staleConnectionErrors = ["socket hang up", "socket stalled"], _this14.request = /*#__PURE__*/function () {
      var _ref34 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee50(t) {
        return _regenerator["default"].wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                _this14.logger.debug("Publishing Request Payload");

                _context50.prev = 1;
                _context50.next = 4;
                return _this14.toEstablishConnection();

              case 4:
                _context50.next = 6;
                return _this14.provider.request(t);

              case 6:
                return _context50.abrupt("return", _context50.sent);

              case 9:
                _context50.prev = 9;
                _context50.t0 = _context50["catch"](1);
                throw _this14.logger.debug("Failed to Publish Request"), _this14.logger.error(_context50.t0), _context50.t0;

              case 12:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50, null, [[1, 9]]);
      }));

      return function (_x48) {
        return _ref34.apply(this, arguments);
      };
    }(), _this14.core = e.core, _this14.logger = _typeof(e.logger) < "u" && typeof e.logger != "string" ? (0, _logger.generateChildLogger)(e.logger, _this14.name) : (0, _logger.pino)((0, _logger.getDefaultLoggerOptions)({
      level: e.logger || rt
    })), _this14.messages = new It(_this14.logger, e.core), _this14.subscriber = new Rt(_assertThisInitialized(_this14), _this14.logger), _this14.publisher = new ur(_assertThisInitialized(_this14), _this14.logger), _this14.relayUrl = (e === null || e === void 0 ? void 0 : e.relayUrl) || le, _this14.projectId = e.projectId, _this14.provider = {};
    return _this14;
  }

  _createClass(Pt, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee52() {
        var _this15 = this;

        return _regenerator["default"].wrap(function _callee52$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                this.logger.trace("Initialized");
                _context52.next = 3;
                return this.createProvider();

              case 3:
                _context52.next = 5;
                return Promise.all([this.messages.init(), this.transportOpen(), this.subscriber.init()]);

              case 5:
                this.registerEventListeners();
                this.initialized = !0;
                setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee51() {
                  return _regenerator["default"].wrap(function _callee51$(_context51) {
                    while (1) {
                      switch (_context51.prev = _context51.next) {
                        case 0:
                          _context51.t0 = _this15.subscriber.topics.length === 0;

                          if (!_context51.t0) {
                            _context51.next = 6;
                            break;
                          }

                          _this15.logger.info("No topics subscribted to after init, closing transport");

                          _context51.next = 5;
                          return _this15.transportClose();

                        case 5:
                          _this15.transportExplicitlyClosed = !1;

                        case 6:
                        case "end":
                          return _context51.stop();
                      }
                    }
                  }, _callee51);
                })), ct);

              case 8:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee52, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "context",
    get: function get() {
      return (0, _logger.getLoggerContext)(this.logger);
    }
  }, {
    key: "connected",
    get: function get() {
      return this.provider.connection.connected;
    }
  }, {
    key: "connecting",
    get: function get() {
      return this.provider.connection.connecting;
    }
  }, {
    key: "publish",
    value: function () {
      var _publish = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee53(e, t, i) {
        return _regenerator["default"].wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                this.isInitialized();
                _context53.next = 3;
                return this.publisher.publish(e, t, i);

              case 3:
                _context53.next = 5;
                return this.recordMessageEvent({
                  topic: e,
                  message: t,
                  publishedAt: Date.now()
                });

              case 5:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53, this);
      }));

      function publish(_x49, _x50, _x51) {
        return _publish.apply(this, arguments);
      }

      return publish;
    }()
  }, {
    key: "subscribe",
    value: function () {
      var _subscribe = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee55(e, t) {
        var _this16 = this;

        var i, s;
        return _regenerator["default"].wrap(function _callee55$(_context55) {
          while (1) {
            switch (_context55.prev = _context55.next) {
              case 0:
                this.isInitialized();
                s = ((i = this.subscriber.topicMap.get(e)) == null ? void 0 : i[0]) || "";
                _context55.t0 = s;

                if (_context55.t0) {
                  _context55.next = 7;
                  break;
                }

                _context55.next = 6;
                return Promise.all([new Promise(function (n) {
                  _this16.subscriber.once(C.created, function (a) {
                    a.topic === e && n();
                  });
                }), new Promise( /*#__PURE__*/function () {
                  var _ref36 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee54(n) {
                    return _regenerator["default"].wrap(function _callee54$(_context54) {
                      while (1) {
                        switch (_context54.prev = _context54.next) {
                          case 0:
                            _context54.next = 2;
                            return _this16.subscriber.subscribe(e, t);

                          case 2:
                            s = _context54.sent;
                            n();

                          case 4:
                          case "end":
                            return _context54.stop();
                        }
                      }
                    }, _callee54);
                  }));

                  return function (_x54) {
                    return _ref36.apply(this, arguments);
                  };
                }())]);

              case 6:
                _context55.t0 = s;

              case 7:
                return _context55.abrupt("return", _context55.t0);

              case 8:
              case "end":
                return _context55.stop();
            }
          }
        }, _callee55, this);
      }));

      function subscribe(_x52, _x53) {
        return _subscribe.apply(this, arguments);
      }

      return subscribe;
    }()
  }, {
    key: "unsubscribe",
    value: function () {
      var _unsubscribe = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee56(e, t) {
        return _regenerator["default"].wrap(function _callee56$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                this.isInitialized();
                _context56.next = 3;
                return this.subscriber.unsubscribe(e, t);

              case 3:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee56, this);
      }));

      function unsubscribe(_x55, _x56) {
        return _unsubscribe.apply(this, arguments);
      }

      return unsubscribe;
    }()
  }, {
    key: "on",
    value: function on(e, t) {
      this.events.on(e, t);
    }
  }, {
    key: "once",
    value: function once(e, t) {
      this.events.once(e, t);
    }
  }, {
    key: "off",
    value: function off(e, t) {
      this.events.off(e, t);
    }
  }, {
    key: "removeListener",
    value: function removeListener(e, t) {
      this.events.removeListener(e, t);
    }
  }, {
    key: "transportClose",
    value: function () {
      var _transportClose = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee57() {
        return _regenerator["default"].wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                this.transportExplicitlyClosed = !0;
                _context57.t0 = this.connected;

                if (!_context57.t0) {
                  _context57.next = 6;
                  break;
                }

                _context57.next = 5;
                return this.provider.disconnect();

              case 5:
                this.events.emit(g.transport_closed);

              case 6:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57, this);
      }));

      function transportClose() {
        return _transportClose.apply(this, arguments);
      }

      return transportClose;
    }()
  }, {
    key: "transportOpen",
    value: function () {
      var _transportOpen = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee59(e) {
        var _this17 = this;

        var i;
        return _regenerator["default"].wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                if (!(this.transportExplicitlyClosed = !1, !this.reconnecting)) {
                  _context59.next = 23;
                  break;
                }

                this.relayUrl = e || this.relayUrl, this.reconnecting = !0;
                _context59.prev = 2;
                _context59.t0 = Promise;
                _context59.t1 = new Promise(function (t) {
                  _this17.initialized || t(), _this17.subscriber.once(C.resubscribed, function () {
                    t();
                  });
                });
                _context59.next = 7;
                return Promise.race([new Promise( /*#__PURE__*/function () {
                  var _ref37 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee58(t, i) {
                    return _regenerator["default"].wrap(function _callee58$(_context58) {
                      while (1) {
                        switch (_context58.prev = _context58.next) {
                          case 0:
                            _context58.next = 2;
                            return (0, _utils.createExpiringPromise)(_this17.provider.connect(), 5e3, "socket stalled")["catch"](function (s) {
                              return i(s);
                            }).then(function () {
                              return t();
                            })["finally"](function () {
                              return _this17.removeListener(g.transport_closed, _this17.rejectTransportOpen);
                            });

                          case 2:
                          case "end":
                            return _context58.stop();
                        }
                      }
                    }, _callee58);
                  }));

                  return function (_x58, _x59) {
                    return _ref37.apply(this, arguments);
                  };
                }()), new Promise(function (t) {
                  return _this17.once(g.transport_closed, _this17.rejectTransportOpen);
                })]);

              case 7:
                _context59.t2 = _context59.sent;
                _context59.t3 = [_context59.t1, _context59.t2];
                _context59.next = 11;
                return _context59.t0.all.call(_context59.t0, _context59.t3);

              case 11:
                _context59.next = 20;
                break;

              case 13:
                _context59.prev = 13;
                _context59.t4 = _context59["catch"](2);
                this.logger.error(_context59.t4);
                i = _context59.t4;

                if (this.isConnectionStalled(i.message)) {
                  _context59.next = 19;
                  break;
                }

                throw _context59.t4;

              case 19:
                this.events.emit(g.transport_closed);

              case 20:
                _context59.prev = 20;
                this.reconnecting = !1;
                return _context59.finish(20);

              case 23:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59, this, [[2, 13, 20, 23]]);
      }));

      function transportOpen(_x57) {
        return _transportOpen.apply(this, arguments);
      }

      return transportOpen;
    }()
  }, {
    key: "restartTransport",
    value: function () {
      var _restartTransport = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee60(e) {
        var _this18 = this;

        return _regenerator["default"].wrap(function _callee60$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                _context60.t0 = this.transportExplicitlyClosed || this.reconnecting;

                if (_context60.t0) {
                  _context60.next = 11;
                  break;
                }

                this.relayUrl = e || this.relayUrl;
                _context60.t1 = this.connected;

                if (!_context60.t1) {
                  _context60.next = 7;
                  break;
                }

                _context60.next = 7;
                return Promise.all([new Promise(function (t) {
                  _this18.provider.once(L.disconnect, function () {
                    t();
                  });
                }), this.transportClose()]);

              case 7:
                _context60.next = 9;
                return this.createProvider();

              case 9:
                _context60.next = 11;
                return this.transportOpen();

              case 11:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee60, this);
      }));

      function restartTransport(_x60) {
        return _restartTransport.apply(this, arguments);
      }

      return restartTransport;
    }()
  }, {
    key: "isConnectionStalled",
    value: function isConnectionStalled(e) {
      return this.staleConnectionErrors.some(function (t) {
        return e.includes(t);
      });
    }
  }, {
    key: "rejectTransportOpen",
    value: function rejectTransportOpen() {
      throw new Error("Attempt to connect to relay via `transportOpen` has stalled. Retrying...");
    }
  }, {
    key: "createProvider",
    value: function () {
      var _createProvider = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee61() {
        var e;
        return _regenerator["default"].wrap(function _callee61$(_context61) {
          while (1) {
            switch (_context61.prev = _context61.next) {
              case 0:
                _context61.next = 2;
                return this.core.crypto.signJWT(this.relayUrl);

              case 2:
                e = _context61.sent;
                this.provider = new _jsonrpcProvider.JsonRpcProvider(new _jsonrpcWsConnection["default"]((0, _utils.formatRelayRpcUrl)({
                  sdkVersion: ht,
                  protocol: this.protocol,
                  version: this.version,
                  relayUrl: this.relayUrl,
                  projectId: this.projectId,
                  auth: e,
                  useOnCloseEvent: !0
                }))), this.registerProviderListeners();

              case 4:
              case "end":
                return _context61.stop();
            }
          }
        }, _callee61, this);
      }));

      function createProvider() {
        return _createProvider.apply(this, arguments);
      }

      return createProvider;
    }()
  }, {
    key: "recordMessageEvent",
    value: function () {
      var _recordMessageEvent = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee62(e) {
        var t, i;
        return _regenerator["default"].wrap(function _callee62$(_context62) {
          while (1) {
            switch (_context62.prev = _context62.next) {
              case 0:
                t = e.topic, i = e.message;
                _context62.next = 3;
                return this.messages.set(t, i);

              case 3:
              case "end":
                return _context62.stop();
            }
          }
        }, _callee62, this);
      }));

      function recordMessageEvent(_x61) {
        return _recordMessageEvent.apply(this, arguments);
      }

      return recordMessageEvent;
    }()
  }, {
    key: "shouldIgnoreMessageEvent",
    value: function () {
      var _shouldIgnoreMessageEvent = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee63(e) {
        var t, i;
        return _regenerator["default"].wrap(function _callee63$(_context63) {
          while (1) {
            switch (_context63.prev = _context63.next) {
              case 0:
                t = e.topic, i = e.message;
                _context63.next = 3;
                return this.subscriber.isSubscribed(t);

              case 3:
                if (!_context63.sent) {
                  _context63.next = 7;
                  break;
                }

                _context63.t0 = this.messages.has(t, i);
                _context63.next = 8;
                break;

              case 7:
                _context63.t0 = !0;

              case 8:
                return _context63.abrupt("return", _context63.t0);

              case 9:
              case "end":
                return _context63.stop();
            }
          }
        }, _callee63, this);
      }));

      function shouldIgnoreMessageEvent(_x62) {
        return _shouldIgnoreMessageEvent.apply(this, arguments);
      }

      return shouldIgnoreMessageEvent;
    }()
  }, {
    key: "onProviderPayload",
    value: function () {
      var _onProviderPayload = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee64(e) {
        var t, _t$data, i, s, n, a;

        return _regenerator["default"].wrap(function _callee64$(_context64) {
          while (1) {
            switch (_context64.prev = _context64.next) {
              case 0:
                if (!(this.logger.debug("Incoming Relay Payload"), this.logger.trace({
                  type: "payload",
                  direction: "incoming",
                  payload: e
                }), (0, _jsonrpcUtils.isJsonRpcRequest)(e))) {
                  _context64.next = 13;
                  break;
                }

                if (e.method.endsWith(at)) {
                  _context64.next = 3;
                  break;
                }

                return _context64.abrupt("return");

              case 3:
                t = e.params, _t$data = t.data, i = _t$data.topic, s = _t$data.message, n = _t$data.publishedAt, a = {
                  topic: i,
                  message: s,
                  publishedAt: n
                };
                this.logger.debug("Emitting Relayer Payload");
                this.logger.trace(fr({
                  type: "event",
                  event: t.id
                }, a));
                this.events.emit(t.id, a);
                _context64.next = 9;
                return this.acknowledgePayload(e);

              case 9:
                _context64.next = 11;
                return this.onMessageEvent(a);

              case 11:
                _context64.next = 14;
                break;

              case 13:
                (0, _jsonrpcUtils.isJsonRpcResponse)(e) && this.events.emit(g.message_ack, e);

              case 14:
              case "end":
                return _context64.stop();
            }
          }
        }, _callee64, this);
      }));

      function onProviderPayload(_x63) {
        return _onProviderPayload.apply(this, arguments);
      }

      return onProviderPayload;
    }()
  }, {
    key: "onMessageEvent",
    value: function () {
      var _onMessageEvent = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee65(e) {
        return _regenerator["default"].wrap(function _callee65$(_context65) {
          while (1) {
            switch (_context65.prev = _context65.next) {
              case 0:
                _context65.next = 2;
                return this.shouldIgnoreMessageEvent(e);

              case 2:
                _context65.t0 = _context65.sent;

                if (_context65.t0) {
                  _context65.next = 7;
                  break;
                }

                this.events.emit(g.message, e);
                _context65.next = 7;
                return this.recordMessageEvent(e);

              case 7:
              case "end":
                return _context65.stop();
            }
          }
        }, _callee65, this);
      }));

      function onMessageEvent(_x64) {
        return _onMessageEvent.apply(this, arguments);
      }

      return onMessageEvent;
    }()
  }, {
    key: "acknowledgePayload",
    value: function () {
      var _acknowledgePayload = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee66(e) {
        var t;
        return _regenerator["default"].wrap(function _callee66$(_context66) {
          while (1) {
            switch (_context66.prev = _context66.next) {
              case 0:
                t = (0, _jsonrpcUtils.formatJsonRpcResult)(e.id, !0);
                _context66.next = 3;
                return this.provider.connection.send(t);

              case 3:
              case "end":
                return _context66.stop();
            }
          }
        }, _callee66, this);
      }));

      function acknowledgePayload(_x65) {
        return _acknowledgePayload.apply(this, arguments);
      }

      return acknowledgePayload;
    }()
  }, {
    key: "registerProviderListeners",
    value: function registerProviderListeners() {
      var _this19 = this;

      this.provider.on(L.payload, function (e) {
        return _this19.onProviderPayload(e);
      }), this.provider.on(L.connect, function () {
        _this19.events.emit(g.connect);
      }), this.provider.on(L.disconnect, function () {
        _this19.onProviderDisconnect();
      }), this.provider.on(L.error, function (e) {
        _this19.logger.error(e), _this19.events.emit(g.error, e);
      });
    }
  }, {
    key: "registerEventListeners",
    value: function registerEventListeners() {
      var _this20 = this;

      this.events.on(g.connection_stalled, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee67() {
        return _regenerator["default"].wrap(function _callee67$(_context67) {
          while (1) {
            switch (_context67.prev = _context67.next) {
              case 0:
                _context67.next = 2;
                return _this20.restartTransport();

              case 2:
              case "end":
                return _context67.stop();
            }
          }
        }, _callee67);
      })));
    }
  }, {
    key: "onProviderDisconnect",
    value: function onProviderDisconnect() {
      this.events.emit(g.disconnect), this.attemptToReconnect();
    }
  }, {
    key: "attemptToReconnect",
    value: function attemptToReconnect() {
      var _this21 = this;

      this.transportExplicitlyClosed || setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee68() {
        return _regenerator["default"].wrap(function _callee68$(_context68) {
          while (1) {
            switch (_context68.prev = _context68.next) {
              case 0:
                _context68.next = 2;
                return _this21.restartTransport();

              case 2:
              case "end":
                return _context68.stop();
            }
          }
        }, _callee68);
      })), (0, _time.toMiliseconds)(ot));
    }
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      if (!this.initialized) {
        var _c8 = (0, _utils.getInternalError)("NOT_INITIALIZED", this.name),
            e = _c8.message;

        throw new Error(e);
      }
    }
  }, {
    key: "toEstablishConnection",
    value: function () {
      var _toEstablishConnection = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee69() {
        var _this22 = this;

        return _regenerator["default"].wrap(function _callee69$(_context69) {
          while (1) {
            switch (_context69.prev = _context69.next) {
              case 0:
                if (this.connected) {
                  _context69.next = 7;
                  break;
                }

                if (!this.connecting) {
                  _context69.next = 5;
                  break;
                }

                _context69.next = 4;
                return new Promise(function (e) {
                  var t = setInterval(function () {
                    _this22.connected && (clearInterval(t), e());
                  }, _this22.connectionStatusPollingInterval);
                });

              case 4:
                return _context69.abrupt("return", _context69.sent);

              case 5:
                _context69.next = 7;
                return this.restartTransport();

              case 7:
              case "end":
                return _context69.stop();
            }
          }
        }, _callee69, this);
      }));

      function toEstablishConnection() {
        return _toEstablishConnection.apply(this, arguments);
      }

      return toEstablishConnection;
    }()
  }]);

  return Pt;
}(_types.IRelayer);

exports.Relayer = Pt;

var wr = Object.defineProperty,
    Ot = Object.getOwnPropertySymbols,
    vr = Object.prototype.hasOwnProperty,
    Ir = Object.prototype.propertyIsEnumerable,
    xt = function xt(r, e, t) {
  return e in r ? wr(r, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : r[e] = t;
},
    At = function At(r, e) {
  for (var t in e || (e = {})) {
    vr.call(e, t) && xt(r, t, e[t]);
  }

  if (Ot) {
    var _iterator4 = _createForOfIteratorHelper(Ot(e)),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var t = _step4.value;
        Ir.call(e, t) && xt(r, t, e[t]);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }

  return r;
};

var zt = /*#__PURE__*/function (_Jt) {
  _inherits(zt, _Jt);

  var _super5 = _createSuper(zt);

  function zt(e, t, i) {
    var _this23;

    var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : O;
    var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : void 0;

    _classCallCheck(this, zt);

    _this23 = _super5.call(this, e, t, i, s), _this23.core = e, _this23.logger = t, _this23.name = i, _this23.map = new Map(), _this23.version = ut, _this23.cached = [], _this23.initialized = !1, _this23.storagePrefix = O, _this23.init = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee70() {
      return _regenerator["default"].wrap(function _callee70$(_context70) {
        while (1) {
          switch (_context70.prev = _context70.next) {
            case 0:
              _context70.t0 = _this23.initialized;

              if (_context70.t0) {
                _context70.next = 8;
                break;
              }

              _this23.logger.trace("Initialized");

              _context70.next = 5;
              return _this23.restore();

            case 5:
              _this23.cached.forEach(function (a) {
                _this23.getKey && a !== null && !(0, _utils.isUndefined)(a) ? _this23.map.set(_this23.getKey(a), a) : (0, _utils.isProposalStruct)(a) ? _this23.map.set(a.id, a) : (0, _utils.isSessionStruct)(a) && _this23.map.set(a.topic, a);
              });

              _this23.cached = [];
              _this23.initialized = !0;

            case 8:
            case "end":
              return _context70.stop();
          }
        }
      }, _callee70);
    })), _this23.set = /*#__PURE__*/function () {
      var _ref41 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee71(a, o) {
        return _regenerator["default"].wrap(function _callee71$(_context71) {
          while (1) {
            switch (_context71.prev = _context71.next) {
              case 0:
                _this23.isInitialized();

                if (!_this23.map.has(a)) {
                  _context71.next = 6;
                  break;
                }

                _context71.next = 4;
                return _this23.update(a, o);

              case 4:
                _context71.next = 11;
                break;

              case 6:
                _this23.logger.debug("Setting value");

                _this23.logger.trace({
                  type: "method",
                  method: "set",
                  key: a,
                  value: o
                });

                _this23.map.set(a, o);

                _context71.next = 11;
                return _this23.persist();

              case 11:
              case "end":
                return _context71.stop();
            }
          }
        }, _callee71);
      }));

      return function (_x66, _x67) {
        return _ref41.apply(this, arguments);
      };
    }(), _this23.get = function (a) {
      return _this23.isInitialized(), _this23.logger.debug("Getting value"), _this23.logger.trace({
        type: "method",
        method: "get",
        key: a
      }), _this23.getData(a);
    }, _this23.getAll = function (a) {
      return _this23.isInitialized(), a ? _this23.values.filter(function (o) {
        return Object.keys(a).every(function (h) {
          return (0, _lodash["default"])(o[h], a[h]);
        });
      }) : _this23.values;
    }, _this23.update = /*#__PURE__*/function () {
      var _ref42 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee72(a, o) {
        var h;
        return _regenerator["default"].wrap(function _callee72$(_context72) {
          while (1) {
            switch (_context72.prev = _context72.next) {
              case 0:
                _this23.isInitialized(), _this23.logger.debug("Updating value"), _this23.logger.trace({
                  type: "method",
                  method: "update",
                  key: a,
                  update: o
                });
                h = At(At({}, _this23.getData(a)), o);

                _this23.map.set(a, h);

                _context72.next = 5;
                return _this23.persist();

              case 5:
              case "end":
                return _context72.stop();
            }
          }
        }, _callee72);
      }));

      return function (_x68, _x69) {
        return _ref42.apply(this, arguments);
      };
    }(), _this23["delete"] = /*#__PURE__*/function () {
      var _ref43 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee73(a, o) {
        return _regenerator["default"].wrap(function _callee73$(_context73) {
          while (1) {
            switch (_context73.prev = _context73.next) {
              case 0:
                _this23.isInitialized();

                _context73.t0 = _this23.map.has(a);

                if (!_context73.t0) {
                  _context73.next = 8;
                  break;
                }

                _this23.logger.debug("Deleting value");

                _this23.logger.trace({
                  type: "method",
                  method: "delete",
                  key: a,
                  reason: o
                });

                _this23.map["delete"](a);

                _context73.next = 8;
                return _this23.persist();

              case 8:
              case "end":
                return _context73.stop();
            }
          }
        }, _callee73);
      }));

      return function (_x70, _x71) {
        return _ref43.apply(this, arguments);
      };
    }(), _this23.logger = (0, _logger.generateChildLogger)(t, _this23.name), _this23.storagePrefix = s, _this23.getKey = n;
    return _this23;
  }

  _createClass(zt, [{
    key: "context",
    get: function get() {
      return (0, _logger.getLoggerContext)(this.logger);
    }
  }, {
    key: "storageKey",
    get: function get() {
      return this.storagePrefix + this.version + "//" + this.name;
    }
  }, {
    key: "length",
    get: function get() {
      return this.map.size;
    }
  }, {
    key: "keys",
    get: function get() {
      return Array.from(this.map.keys());
    }
  }, {
    key: "values",
    get: function get() {
      return Array.from(this.map.values());
    }
  }, {
    key: "setDataStore",
    value: function () {
      var _setDataStore = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee74(e) {
        return _regenerator["default"].wrap(function _callee74$(_context74) {
          while (1) {
            switch (_context74.prev = _context74.next) {
              case 0:
                _context74.next = 2;
                return this.core.storage.setItem(this.storageKey, e);

              case 2:
              case "end":
                return _context74.stop();
            }
          }
        }, _callee74, this);
      }));

      function setDataStore(_x72) {
        return _setDataStore.apply(this, arguments);
      }

      return setDataStore;
    }()
  }, {
    key: "getDataStore",
    value: function () {
      var _getDataStore = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee75() {
        return _regenerator["default"].wrap(function _callee75$(_context75) {
          while (1) {
            switch (_context75.prev = _context75.next) {
              case 0:
                _context75.next = 2;
                return this.core.storage.getItem(this.storageKey);

              case 2:
                return _context75.abrupt("return", _context75.sent);

              case 3:
              case "end":
                return _context75.stop();
            }
          }
        }, _callee75, this);
      }));

      function getDataStore() {
        return _getDataStore.apply(this, arguments);
      }

      return getDataStore;
    }()
  }, {
    key: "getData",
    value: function getData(e) {
      var t = this.map.get(e);

      if (!t) {
        var _c9 = (0, _utils.getInternalError)("NO_MATCHING_KEY", "".concat(this.name, ": ").concat(e)),
            i = _c9.message;

        throw this.logger.error(i), new Error(i);
      }

      return t;
    }
  }, {
    key: "persist",
    value: function () {
      var _persist4 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee76() {
        return _regenerator["default"].wrap(function _callee76$(_context76) {
          while (1) {
            switch (_context76.prev = _context76.next) {
              case 0:
                _context76.next = 2;
                return this.setDataStore(this.values);

              case 2:
              case "end":
                return _context76.stop();
            }
          }
        }, _callee76, this);
      }));

      function persist() {
        return _persist4.apply(this, arguments);
      }

      return persist;
    }()
  }, {
    key: "restore",
    value: function () {
      var _restore2 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee77() {
        var e, _c10, t;

        return _regenerator["default"].wrap(function _callee77$(_context77) {
          while (1) {
            switch (_context77.prev = _context77.next) {
              case 0:
                _context77.prev = 0;
                _context77.next = 3;
                return this.getDataStore();

              case 3:
                e = _context77.sent;

                if (!(_typeof(e) > "u" || !e.length)) {
                  _context77.next = 6;
                  break;
                }

                return _context77.abrupt("return");

              case 6:
                if (!this.map.size) {
                  _context77.next = 9;
                  break;
                }

                _c10 = (0, _utils.getInternalError)("RESTORE_WILL_OVERRIDE", this.name), t = _c10.message;
                throw this.logger.error(t), new Error(t);

              case 9:
                this.cached = e, this.logger.debug("Successfully Restored value for ".concat(this.name)), this.logger.trace({
                  type: "method",
                  method: "restore",
                  value: this.values
                });
                _context77.next = 15;
                break;

              case 12:
                _context77.prev = 12;
                _context77.t0 = _context77["catch"](0);
                this.logger.debug("Failed to Restore value for ".concat(this.name)), this.logger.error(_context77.t0);

              case 15:
              case "end":
                return _context77.stop();
            }
          }
        }, _callee77, this, [[0, 12]]);
      }));

      function restore() {
        return _restore2.apply(this, arguments);
      }

      return restore;
    }()
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      if (!this.initialized) {
        var _c11 = (0, _utils.getInternalError)("NOT_INITIALIZED", this.name),
            e = _c11.message;

        throw new Error(e);
      }
    }
  }]);

  return zt;
}(_types.IStore);

exports.Store = zt;

var Nt = /*#__PURE__*/function () {
  function Nt(e, t) {
    var _this24 = this;

    _classCallCheck(this, Nt);

    this.core = e, this.logger = t, this.name = Dt, this.version = yt, this.events = new _events["default"](), this.initialized = !1, this.storagePrefix = O, this.ignoredPayloadTypes = [_utils.TYPE_1], this.registeredMethods = [], this.init = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee78() {
      return _regenerator["default"].wrap(function _callee78$(_context78) {
        while (1) {
          switch (_context78.prev = _context78.next) {
            case 0:
              _context78.t0 = _this24.initialized;

              if (_context78.t0) {
                _context78.next = 10;
                break;
              }

              _context78.next = 4;
              return _this24.pairings.init();

            case 4:
              _context78.next = 6;
              return _this24.cleanup();

            case 6:
              _this24.registerRelayerEvents();

              _this24.registerExpirerEvents();

              _this24.initialized = !0;

              _this24.logger.trace("Initialized");

            case 10:
            case "end":
              return _context78.stop();
          }
        }
      }, _callee78);
    })), this.register = function (_ref45) {
      var i = _ref45.methods;
      _this24.isInitialized(), _this24.registeredMethods = _toConsumableArray(new Set([].concat(_toConsumableArray(_this24.registeredMethods), _toConsumableArray(i))));
    }, this.create = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee79() {
      var i, s, n, a, o, h;
      return _regenerator["default"].wrap(function _callee79$(_context79) {
        while (1) {
          switch (_context79.prev = _context79.next) {
            case 0:
              _this24.isInitialized();

              i = (0, _utils.generateRandomBytes32)();
              _context79.next = 4;
              return _this24.core.crypto.setSymKey(i);

            case 4:
              s = _context79.sent;
              n = (0, _utils.calcExpiry)(_time.FIVE_MINUTES);
              a = {
                protocol: st
              };
              o = {
                topic: s,
                expiry: n,
                relay: a,
                active: !1
              };
              h = (0, _utils.formatUri)({
                protocol: _this24.core.protocol,
                version: _this24.core.version,
                topic: s,
                symKey: i,
                relay: a
              });
              _context79.next = 11;
              return _this24.pairings.set(s, o);

            case 11:
              _context79.next = 13;
              return _this24.core.relayer.subscribe(s);

            case 13:
              _this24.core.expirer.set(s, n);

              return _context79.abrupt("return", {
                topic: s,
                uri: h
              });

            case 15:
            case "end":
              return _context79.stop();
          }
        }
      }, _callee79);
    })), this.pair = /*#__PURE__*/function () {
      var _ref47 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee80(i) {
        var _yi, s, n, a, o, h;

        return _regenerator["default"].wrap(function _callee80$(_context80) {
          while (1) {
            switch (_context80.prev = _context80.next) {
              case 0:
                _this24.isInitialized(), _this24.isValidPair(i);
                _yi = (0, _utils.parseUri)(i.uri), s = _yi.topic, n = _yi.symKey, a = _yi.relay;

                if (!_this24.pairings.keys.includes(s)) {
                  _context80.next = 4;
                  break;
                }

                throw new Error("Pairing already exists: ".concat(s));

              case 4:
                if (!_this24.core.crypto.hasKeys(s)) {
                  _context80.next = 6;
                  break;
                }

                throw new Error("Keychain already exists: ".concat(s));

              case 6:
                o = (0, _utils.calcExpiry)(_time.FIVE_MINUTES), h = {
                  topic: s,
                  relay: a,
                  expiry: o,
                  active: !1
                };
                _context80.next = 9;
                return _this24.pairings.set(s, h);

              case 9:
                _context80.next = 11;
                return _this24.core.crypto.setSymKey(n, s);

              case 11:
                _context80.next = 13;
                return _this24.core.relayer.subscribe(s, {
                  relay: a
                });

              case 13:
                _this24.core.expirer.set(s, o);

                _context80.t0 = i.activatePairing;

                if (!_context80.t0) {
                  _context80.next = 18;
                  break;
                }

                _context80.next = 18;
                return _this24.activate({
                  topic: s
                });

              case 18:
                return _context80.abrupt("return", h);

              case 19:
              case "end":
                return _context80.stop();
            }
          }
        }, _callee80);
      }));

      return function (_x73) {
        return _ref47.apply(this, arguments);
      };
    }(), this.activate = /*#__PURE__*/function () {
      var _ref49 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee81(_ref48) {
        var i, s;
        return _regenerator["default"].wrap(function _callee81$(_context81) {
          while (1) {
            switch (_context81.prev = _context81.next) {
              case 0:
                i = _ref48.topic;

                _this24.isInitialized();

                s = (0, _utils.calcExpiry)(_time.THIRTY_DAYS);
                _context81.next = 5;
                return _this24.pairings.update(i, {
                  active: !0,
                  expiry: s
                });

              case 5:
                _this24.core.expirer.set(i, s);

              case 6:
              case "end":
                return _context81.stop();
            }
          }
        }, _callee81);
      }));

      return function (_x74) {
        return _ref49.apply(this, arguments);
      };
    }(), this.ping = /*#__PURE__*/function () {
      var _ref50 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee82(i) {
        var s, n, _bi, a, o, h;

        return _regenerator["default"].wrap(function _callee82$(_context82) {
          while (1) {
            switch (_context82.prev = _context82.next) {
              case 0:
                _this24.isInitialized();

                _context82.next = 3;
                return _this24.isValidPing(i);

              case 3:
                s = i.topic;

                if (!_this24.pairings.keys.includes(s)) {
                  _context82.next = 15;
                  break;
                }

                _context82.next = 7;
                return _this24.sendRequest(s, "wc_pairingPing", {});

              case 7:
                n = _context82.sent;
                _bi = (0, _utils.createDelayedPromise)();
                a = _bi.done;
                o = _bi.resolve;
                h = _bi.reject;

                _this24.events.once((0, _utils.engineEvent)("pairing_ping", n), function (_ref51) {
                  var d = _ref51.error;
                  d ? h(d) : o();
                });

                _context82.next = 15;
                return a();

              case 15:
              case "end":
                return _context82.stop();
            }
          }
        }, _callee82);
      }));

      return function (_x75) {
        return _ref50.apply(this, arguments);
      };
    }(), this.updateExpiry = /*#__PURE__*/function () {
      var _ref53 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee83(_ref52) {
        var i, s;
        return _regenerator["default"].wrap(function _callee83$(_context83) {
          while (1) {
            switch (_context83.prev = _context83.next) {
              case 0:
                i = _ref52.topic, s = _ref52.expiry;

                _this24.isInitialized();

                _context83.next = 4;
                return _this24.pairings.update(i, {
                  expiry: s
                });

              case 4:
              case "end":
                return _context83.stop();
            }
          }
        }, _callee83);
      }));

      return function (_x76) {
        return _ref53.apply(this, arguments);
      };
    }(), this.updateMetadata = /*#__PURE__*/function () {
      var _ref55 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee84(_ref54) {
        var i, s;
        return _regenerator["default"].wrap(function _callee84$(_context84) {
          while (1) {
            switch (_context84.prev = _context84.next) {
              case 0:
                i = _ref54.topic, s = _ref54.metadata;

                _this24.isInitialized();

                _context84.next = 4;
                return _this24.pairings.update(i, {
                  peerMetadata: s
                });

              case 4:
              case "end":
                return _context84.stop();
            }
          }
        }, _callee84);
      }));

      return function (_x77) {
        return _ref55.apply(this, arguments);
      };
    }(), this.getPairings = function () {
      return _this24.isInitialized(), _this24.pairings.values;
    }, this.disconnect = /*#__PURE__*/function () {
      var _ref56 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee85(i) {
        var s;
        return _regenerator["default"].wrap(function _callee85$(_context85) {
          while (1) {
            switch (_context85.prev = _context85.next) {
              case 0:
                _this24.isInitialized();

                _context85.next = 3;
                return _this24.isValidDisconnect(i);

              case 3:
                s = i.topic;
                _context85.t0 = _this24.pairings.keys.includes(s);

                if (!_context85.t0) {
                  _context85.next = 10;
                  break;
                }

                _context85.next = 8;
                return _this24.sendRequest(s, "wc_pairingDelete", (0, _utils.getSdkError)("USER_DISCONNECTED"));

              case 8:
                _context85.next = 10;
                return _this24.deletePairing(s);

              case 10:
              case "end":
                return _context85.stop();
            }
          }
        }, _callee85);
      }));

      return function (_x78) {
        return _ref56.apply(this, arguments);
      };
    }(), this.sendRequest = /*#__PURE__*/function () {
      var _ref57 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee86(i, s, n) {
        var a, o, h;
        return _regenerator["default"].wrap(function _callee86$(_context86) {
          while (1) {
            switch (_context86.prev = _context86.next) {
              case 0:
                a = (0, _jsonrpcUtils.formatJsonRpcRequest)(s, n);
                _context86.next = 3;
                return _this24.core.crypto.encode(i, a);

              case 3:
                o = _context86.sent;
                h = F[s].req;
                return _context86.abrupt("return", (_this24.core.history.set(i, a), _this24.core.relayer.publish(i, o, h), a.id));

              case 6:
              case "end":
                return _context86.stop();
            }
          }
        }, _callee86);
      }));

      return function (_x79, _x80, _x81) {
        return _ref57.apply(this, arguments);
      };
    }(), this.sendResult = /*#__PURE__*/function () {
      var _ref58 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee87(i, s, n) {
        var a, o, h, d;
        return _regenerator["default"].wrap(function _callee87$(_context87) {
          while (1) {
            switch (_context87.prev = _context87.next) {
              case 0:
                a = (0, _jsonrpcUtils.formatJsonRpcResult)(i, n);
                _context87.next = 3;
                return _this24.core.crypto.encode(s, a);

              case 3:
                o = _context87.sent;
                _context87.next = 6;
                return _this24.core.history.get(s, i);

              case 6:
                h = _context87.sent;
                d = F[h.request.method].res;
                _context87.next = 10;
                return _this24.core.relayer.publish(s, o, d);

              case 10:
                _context87.next = 12;
                return _this24.core.history.resolve(a);

              case 12:
              case "end":
                return _context87.stop();
            }
          }
        }, _callee87);
      }));

      return function (_x82, _x83, _x84) {
        return _ref58.apply(this, arguments);
      };
    }(), this.sendError = /*#__PURE__*/function () {
      var _ref59 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee88(i, s, n) {
        var a, o, h, d;
        return _regenerator["default"].wrap(function _callee88$(_context88) {
          while (1) {
            switch (_context88.prev = _context88.next) {
              case 0:
                a = (0, _jsonrpcUtils.formatJsonRpcError)(i, n);
                _context88.next = 3;
                return _this24.core.crypto.encode(s, a);

              case 3:
                o = _context88.sent;
                _context88.next = 6;
                return _this24.core.history.get(s, i);

              case 6:
                h = _context88.sent;
                d = F[h.request.method] ? F[h.request.method].res : F.unregistered_method.res;
                _context88.next = 10;
                return _this24.core.relayer.publish(s, o, d);

              case 10:
                _context88.next = 12;
                return _this24.core.history.resolve(a);

              case 12:
              case "end":
                return _context88.stop();
            }
          }
        }, _callee88);
      }));

      return function (_x85, _x86, _x87) {
        return _ref59.apply(this, arguments);
      };
    }(), this.deletePairing = /*#__PURE__*/function () {
      var _ref60 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee89(i, s) {
        return _regenerator["default"].wrap(function _callee89$(_context89) {
          while (1) {
            switch (_context89.prev = _context89.next) {
              case 0:
                _context89.next = 2;
                return _this24.core.relayer.unsubscribe(i);

              case 2:
                _context89.next = 4;
                return Promise.all([_this24.pairings["delete"](i, (0, _utils.getSdkError)("USER_DISCONNECTED")), _this24.core.crypto.deleteSymKey(i), s ? Promise.resolve() : _this24.core.expirer.del(i)]);

              case 4:
              case "end":
                return _context89.stop();
            }
          }
        }, _callee89);
      }));

      return function (_x88, _x89) {
        return _ref60.apply(this, arguments);
      };
    }(), this.cleanup = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee90() {
      var i;
      return _regenerator["default"].wrap(function _callee90$(_context90) {
        while (1) {
          switch (_context90.prev = _context90.next) {
            case 0:
              i = _this24.pairings.getAll().filter(function (s) {
                return (0, _utils.isExpired)(s.expiry);
              });
              _context90.next = 3;
              return Promise.all(i.map(function (s) {
                return _this24.deletePairing(s.topic);
              }));

            case 3:
            case "end":
              return _context90.stop();
          }
        }
      }, _callee90);
    })), this.onRelayEventRequest = function (i) {
      var s = i.topic,
          n = i.payload,
          a = n.method;
      if (_this24.pairings.keys.includes(s)) switch (a) {
        case "wc_pairingPing":
          return _this24.onPairingPingRequest(s, n);

        case "wc_pairingDelete":
          return _this24.onPairingDeleteRequest(s, n);

        default:
          return _this24.onUnknownRpcMethodRequest(s, n);
      }
    }, this.onRelayEventResponse = /*#__PURE__*/function () {
      var _ref62 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee91(i) {
        var s, n, a;
        return _regenerator["default"].wrap(function _callee91$(_context91) {
          while (1) {
            switch (_context91.prev = _context91.next) {
              case 0:
                s = i.topic;
                n = i.payload;
                _context91.next = 4;
                return _this24.core.history.get(s, n.id);

              case 4:
                a = _context91.sent.request.method;

                if (!_this24.pairings.keys.includes(s)) {
                  _context91.next = 11;
                  break;
                }

                _context91.t0 = a;
                _context91.next = _context91.t0 === "wc_pairingPing" ? 9 : 10;
                break;

              case 9:
                return _context91.abrupt("return", _this24.onPairingPingResponse(s, n));

              case 10:
                return _context91.abrupt("return", _this24.onUnknownRpcMethodResponse(a));

              case 11:
              case "end":
                return _context91.stop();
            }
          }
        }, _callee91);
      }));

      return function (_x90) {
        return _ref62.apply(this, arguments);
      };
    }(), this.onPairingPingRequest = /*#__PURE__*/function () {
      var _ref63 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee92(i, s) {
        var n;
        return _regenerator["default"].wrap(function _callee92$(_context92) {
          while (1) {
            switch (_context92.prev = _context92.next) {
              case 0:
                n = s.id;
                _context92.prev = 1;

                _this24.isValidPing({
                  topic: i
                });

                _context92.next = 5;
                return _this24.sendResult(n, i, !0);

              case 5:
                _this24.events.emit("pairing_ping", {
                  id: n,
                  topic: i
                });

                _context92.next = 13;
                break;

              case 8:
                _context92.prev = 8;
                _context92.t0 = _context92["catch"](1);
                _context92.next = 12;
                return _this24.sendError(n, i, _context92.t0);

              case 12:
                _this24.logger.error(_context92.t0);

              case 13:
              case "end":
                return _context92.stop();
            }
          }
        }, _callee92, null, [[1, 8]]);
      }));

      return function (_x91, _x92) {
        return _ref63.apply(this, arguments);
      };
    }(), this.onPairingPingResponse = function (i, s) {
      var n = s.id;
      setTimeout(function () {
        (0, _jsonrpcUtils.isJsonRpcResult)(s) ? _this24.events.emit((0, _utils.engineEvent)("pairing_ping", n), {}) : (0, _jsonrpcUtils.isJsonRpcError)(s) && _this24.events.emit((0, _utils.engineEvent)("pairing_ping", n), {
          error: s.error
        });
      }, 500);
    }, this.onPairingDeleteRequest = /*#__PURE__*/function () {
      var _ref64 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee93(i, s) {
        var n;
        return _regenerator["default"].wrap(function _callee93$(_context93) {
          while (1) {
            switch (_context93.prev = _context93.next) {
              case 0:
                n = s.id;
                _context93.prev = 1;

                _this24.isValidDisconnect({
                  topic: i
                });

                _context93.next = 5;
                return _this24.deletePairing(i);

              case 5:
                _this24.events.emit("pairing_delete", {
                  id: n,
                  topic: i
                });

                _context93.next = 13;
                break;

              case 8:
                _context93.prev = 8;
                _context93.t0 = _context93["catch"](1);
                _context93.next = 12;
                return _this24.sendError(n, i, _context93.t0);

              case 12:
                _this24.logger.error(_context93.t0);

              case 13:
              case "end":
                return _context93.stop();
            }
          }
        }, _callee93, null, [[1, 8]]);
      }));

      return function (_x93, _x94) {
        return _ref64.apply(this, arguments);
      };
    }(), this.onUnknownRpcMethodRequest = /*#__PURE__*/function () {
      var _ref65 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee94(i, s) {
        var n, a, o;
        return _regenerator["default"].wrap(function _callee94$(_context94) {
          while (1) {
            switch (_context94.prev = _context94.next) {
              case 0:
                n = s.id, a = s.method;
                _context94.prev = 1;

                if (!_this24.registeredMethods.includes(a)) {
                  _context94.next = 4;
                  break;
                }

                return _context94.abrupt("return");

              case 4:
                o = (0, _utils.getSdkError)("WC_METHOD_UNSUPPORTED", a);
                _context94.next = 7;
                return _this24.sendError(n, i, o);

              case 7:
                _this24.logger.error(o);

                _context94.next = 15;
                break;

              case 10:
                _context94.prev = 10;
                _context94.t0 = _context94["catch"](1);
                _context94.next = 14;
                return _this24.sendError(n, i, _context94.t0);

              case 14:
                _this24.logger.error(_context94.t0);

              case 15:
              case "end":
                return _context94.stop();
            }
          }
        }, _callee94, null, [[1, 10]]);
      }));

      return function (_x95, _x96) {
        return _ref65.apply(this, arguments);
      };
    }(), this.onUnknownRpcMethodResponse = function (i) {
      _this24.registeredMethods.includes(i) || _this24.logger.error((0, _utils.getSdkError)("WC_METHOD_UNSUPPORTED", i));
    }, this.isValidPair = function (i) {
      if (!(0, _utils.isValidParams)(i)) {
        var _c12 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "pair() params: ".concat(i)),
            s = _c12.message;

        throw new Error(s);
      }

      if (!(0, _utils.isValidUrl)(i.uri)) {
        var _c13 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "pair() uri: ".concat(i.uri)),
            _s2 = _c13.message;

        throw new Error(_s2);
      }
    }, this.isValidPing = /*#__PURE__*/function () {
      var _ref66 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee95(i) {
        var _c14, n, s;

        return _regenerator["default"].wrap(function _callee95$(_context95) {
          while (1) {
            switch (_context95.prev = _context95.next) {
              case 0:
                if ((0, _utils.isValidParams)(i)) {
                  _context95.next = 3;
                  break;
                }

                _c14 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "ping() params: ".concat(i)), n = _c14.message;
                throw new Error(n);

              case 3:
                s = i.topic;
                _context95.next = 6;
                return _this24.isValidPairingTopic(s);

              case 6:
              case "end":
                return _context95.stop();
            }
          }
        }, _callee95);
      }));

      return function (_x97) {
        return _ref66.apply(this, arguments);
      };
    }(), this.isValidDisconnect = /*#__PURE__*/function () {
      var _ref67 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee96(i) {
        var _c15, n, s;

        return _regenerator["default"].wrap(function _callee96$(_context96) {
          while (1) {
            switch (_context96.prev = _context96.next) {
              case 0:
                if ((0, _utils.isValidParams)(i)) {
                  _context96.next = 3;
                  break;
                }

                _c15 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "disconnect() params: ".concat(i)), n = _c15.message;
                throw new Error(n);

              case 3:
                s = i.topic;
                _context96.next = 6;
                return _this24.isValidPairingTopic(s);

              case 6:
              case "end":
                return _context96.stop();
            }
          }
        }, _callee96);
      }));

      return function (_x98) {
        return _ref67.apply(this, arguments);
      };
    }(), this.isValidPairingTopic = /*#__PURE__*/function () {
      var _ref68 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee97(i) {
        var _c16, s, _c17, _s3, _c18, _s4;

        return _regenerator["default"].wrap(function _callee97$(_context97) {
          while (1) {
            switch (_context97.prev = _context97.next) {
              case 0:
                if ((0, _utils.isValidString)(i, !1)) {
                  _context97.next = 3;
                  break;
                }

                _c16 = (0, _utils.getInternalError)("MISSING_OR_INVALID", "pairing topic should be a string: ".concat(i)), s = _c16.message;
                throw new Error(s);

              case 3:
                if (_this24.pairings.keys.includes(i)) {
                  _context97.next = 6;
                  break;
                }

                _c17 = (0, _utils.getInternalError)("NO_MATCHING_KEY", "pairing topic doesn't exist: ".concat(i)), _s3 = _c17.message;
                throw new Error(_s3);

              case 6:
                if (!(0, _utils.isExpired)(_this24.pairings.get(i).expiry)) {
                  _context97.next = 11;
                  break;
                }

                _context97.next = 9;
                return _this24.deletePairing(i);

              case 9:
                _c18 = (0, _utils.getInternalError)("EXPIRED", "pairing topic: ".concat(i)), _s4 = _c18.message;
                throw new Error(_s4);

              case 11:
              case "end":
                return _context97.stop();
            }
          }
        }, _callee97);
      }));

      return function (_x99) {
        return _ref68.apply(this, arguments);
      };
    }(), this.core = e, this.logger = (0, _logger.generateChildLogger)(t, this.name), this.pairings = new zt(this.core, this.logger, this.name, this.storagePrefix);
  }

  _createClass(Nt, [{
    key: "context",
    get: function get() {
      return (0, _logger.getLoggerContext)(this.logger);
    }
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      if (!this.initialized) {
        var _c19 = (0, _utils.getInternalError)("NOT_INITIALIZED", this.name),
            e = _c19.message;

        throw new Error(e);
      }
    }
  }, {
    key: "registerRelayerEvents",
    value: function registerRelayerEvents() {
      var _this25 = this;

      this.core.relayer.on(g.message, /*#__PURE__*/function () {
        var _ref69 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee98(e) {
          var t, i, s;
          return _regenerator["default"].wrap(function _callee98$(_context98) {
            while (1) {
              switch (_context98.prev = _context98.next) {
                case 0:
                  t = e.topic, i = e.message;

                  if (!_this25.ignoredPayloadTypes.includes(_this25.core.crypto.getPayloadType(i))) {
                    _context98.next = 3;
                    break;
                  }

                  return _context98.abrupt("return");

                case 3:
                  _context98.next = 5;
                  return _this25.core.crypto.decode(t, i);

                case 5:
                  s = _context98.sent;

                  if (!(0, _jsonrpcUtils.isJsonRpcRequest)(s)) {
                    _context98.next = 10;
                    break;
                  }

                  _this25.core.history.set(t, s), _this25.onRelayEventRequest({
                    topic: t,
                    payload: s
                  });
                  _context98.next = 15;
                  break;

                case 10:
                  _context98.t0 = (0, _jsonrpcUtils.isJsonRpcResponse)(s);

                  if (!_context98.t0) {
                    _context98.next = 15;
                    break;
                  }

                  _context98.next = 14;
                  return _this25.core.history.resolve(s);

                case 14:
                  _this25.onRelayEventResponse({
                    topic: t,
                    payload: s
                  });

                case 15:
                case "end":
                  return _context98.stop();
              }
            }
          }, _callee98);
        }));

        return function (_x100) {
          return _ref69.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "registerExpirerEvents",
    value: function registerExpirerEvents() {
      var _this26 = this;

      this.core.expirer.on(w.expired, /*#__PURE__*/function () {
        var _ref70 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee99(e) {
          var _fi, t;

          return _regenerator["default"].wrap(function _callee99$(_context99) {
            while (1) {
              switch (_context99.prev = _context99.next) {
                case 0:
                  _fi = (0, _utils.parseExpirerTarget)(e.target), t = _fi.topic;
                  _context99.t0 = t && _this26.pairings.keys.includes(t);

                  if (!_context99.t0) {
                    _context99.next = 6;
                    break;
                  }

                  _context99.next = 5;
                  return _this26.deletePairing(t, !0);

                case 5:
                  _this26.events.emit("pairing_expire", {
                    topic: t
                  });

                case 6:
                case "end":
                  return _context99.stop();
              }
            }
          }, _callee99);
        }));

        return function (_x101) {
          return _ref70.apply(this, arguments);
        };
      }());
    }
  }]);

  return Nt;
}();

exports.Pairing = Nt;

var Ut = /*#__PURE__*/function (_Ht) {
  _inherits(Ut, _Ht);

  var _super6 = _createSuper(Ut);

  function Ut(e, t) {
    var _this27;

    _classCallCheck(this, Ut);

    _this27 = _super6.call(this, e, t), _this27.core = e, _this27.logger = t, _this27.records = new Map(), _this27.events = new _events.EventEmitter(), _this27.name = bt, _this27.version = mt, _this27.cached = [], _this27.initialized = !1, _this27.storagePrefix = O, _this27.init = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee100() {
      return _regenerator["default"].wrap(function _callee100$(_context100) {
        while (1) {
          switch (_context100.prev = _context100.next) {
            case 0:
              _context100.t0 = _this27.initialized;

              if (_context100.t0) {
                _context100.next = 9;
                break;
              }

              _this27.logger.trace("Initialized");

              _context100.next = 5;
              return _this27.restore();

            case 5:
              _this27.cached.forEach(function (i) {
                return _this27.records.set(i.id, i);
              });

              _this27.cached = [];

              _this27.registerEventListeners();

              _this27.initialized = !0;

            case 9:
            case "end":
              return _context100.stop();
          }
        }
      }, _callee100);
    })), _this27.set = function (i, s, n) {
      if (_this27.isInitialized(), _this27.logger.debug("Setting JSON-RPC request history record"), _this27.logger.trace({
        type: "method",
        method: "set",
        topic: i,
        request: s,
        chainId: n
      }), _this27.records.has(s.id)) return;
      var a = {
        id: s.id,
        topic: i,
        request: {
          method: s.method,
          params: s.params || null
        },
        chainId: n
      };
      _this27.records.set(a.id, a), _this27.events.emit(_.created, a);
    }, _this27.resolve = /*#__PURE__*/function () {
      var _ref72 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee101(i) {
        var s;
        return _regenerator["default"].wrap(function _callee101$(_context101) {
          while (1) {
            switch (_context101.prev = _context101.next) {
              case 0:
                if (!(_this27.isInitialized(), _this27.logger.debug("Updating JSON-RPC response history record"), _this27.logger.trace({
                  type: "method",
                  method: "update",
                  response: i
                }), !_this27.records.has(i.id))) {
                  _context101.next = 2;
                  break;
                }

                return _context101.abrupt("return");

              case 2:
                _context101.next = 4;
                return _this27.getRecord(i.id);

              case 4:
                s = _context101.sent;
                _typeof(s.response) > "u" && (s.response = (0, _jsonrpcUtils.isJsonRpcError)(i) ? {
                  error: i.error
                } : {
                  result: i.result
                }, _this27.records.set(s.id, s), _this27.events.emit(_.updated, s));

              case 6:
              case "end":
                return _context101.stop();
            }
          }
        }, _callee101);
      }));

      return function (_x102) {
        return _ref72.apply(this, arguments);
      };
    }(), _this27.get = /*#__PURE__*/function () {
      var _ref73 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee102(i, s) {
        return _regenerator["default"].wrap(function _callee102$(_context102) {
          while (1) {
            switch (_context102.prev = _context102.next) {
              case 0:
                _this27.isInitialized();

                _this27.logger.debug("Getting record");

                _this27.logger.trace({
                  type: "method",
                  method: "get",
                  topic: i,
                  id: s
                });

                _context102.next = 5;
                return _this27.getRecord(s);

              case 5:
                return _context102.abrupt("return", _context102.sent);

              case 6:
              case "end":
                return _context102.stop();
            }
          }
        }, _callee102);
      }));

      return function (_x103, _x104) {
        return _ref73.apply(this, arguments);
      };
    }(), _this27["delete"] = function (i, s) {
      _this27.isInitialized(), _this27.logger.debug("Deleting record"), _this27.logger.trace({
        type: "method",
        method: "delete",
        id: s
      }), _this27.values.forEach(function (n) {
        if (n.topic === i) {
          if (_typeof(s) < "u" && n.id !== s) return;
          _this27.records["delete"](n.id), _this27.events.emit(_.deleted, n);
        }
      });
    }, _this27.exists = /*#__PURE__*/function () {
      var _ref74 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee103(i, s) {
        return _regenerator["default"].wrap(function _callee103$(_context103) {
          while (1) {
            switch (_context103.prev = _context103.next) {
              case 0:
                _this27.isInitialized();

                if (!_this27.records.has(s)) {
                  _context103.next = 9;
                  break;
                }

                _context103.next = 4;
                return _this27.getRecord(s);

              case 4:
                _context103.t1 = _context103.sent.topic;
                _context103.t2 = i;
                _context103.t0 = _context103.t1 === _context103.t2;
                _context103.next = 10;
                break;

              case 9:
                _context103.t0 = !1;

              case 10:
                return _context103.abrupt("return", _context103.t0);

              case 11:
              case "end":
                return _context103.stop();
            }
          }
        }, _callee103);
      }));

      return function (_x105, _x106) {
        return _ref74.apply(this, arguments);
      };
    }(), _this27.on = function (i, s) {
      _this27.events.on(i, s);
    }, _this27.once = function (i, s) {
      _this27.events.once(i, s);
    }, _this27.off = function (i, s) {
      _this27.events.off(i, s);
    }, _this27.removeListener = function (i, s) {
      _this27.events.removeListener(i, s);
    }, _this27.logger = (0, _logger.generateChildLogger)(t, _this27.name);
    return _this27;
  }

  _createClass(Ut, [{
    key: "context",
    get: function get() {
      return (0, _logger.getLoggerContext)(this.logger);
    }
  }, {
    key: "storageKey",
    get: function get() {
      return this.storagePrefix + this.version + "//" + this.name;
    }
  }, {
    key: "size",
    get: function get() {
      return this.records.size;
    }
  }, {
    key: "keys",
    get: function get() {
      return Array.from(this.records.keys());
    }
  }, {
    key: "values",
    get: function get() {
      return Array.from(this.records.values());
    }
  }, {
    key: "pending",
    get: function get() {
      var e = [];
      return this.values.forEach(function (t) {
        if (_typeof(t.response) < "u") return;
        var i = {
          topic: t.topic,
          request: (0, _jsonrpcUtils.formatJsonRpcRequest)(t.request.method, t.request.params, t.id),
          chainId: t.chainId
        };
        return e.push(i);
      }), e;
    }
  }, {
    key: "setJsonRpcRecords",
    value: function () {
      var _setJsonRpcRecords = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee104(e) {
        return _regenerator["default"].wrap(function _callee104$(_context104) {
          while (1) {
            switch (_context104.prev = _context104.next) {
              case 0:
                _context104.next = 2;
                return this.core.storage.setItem(this.storageKey, e);

              case 2:
              case "end":
                return _context104.stop();
            }
          }
        }, _callee104, this);
      }));

      function setJsonRpcRecords(_x107) {
        return _setJsonRpcRecords.apply(this, arguments);
      }

      return setJsonRpcRecords;
    }()
  }, {
    key: "getJsonRpcRecords",
    value: function () {
      var _getJsonRpcRecords = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee105() {
        return _regenerator["default"].wrap(function _callee105$(_context105) {
          while (1) {
            switch (_context105.prev = _context105.next) {
              case 0:
                _context105.next = 2;
                return this.core.storage.getItem(this.storageKey);

              case 2:
                return _context105.abrupt("return", _context105.sent);

              case 3:
              case "end":
                return _context105.stop();
            }
          }
        }, _callee105, this);
      }));

      function getJsonRpcRecords() {
        return _getJsonRpcRecords.apply(this, arguments);
      }

      return getJsonRpcRecords;
    }()
  }, {
    key: "getRecord",
    value: function getRecord(e) {
      this.isInitialized();
      var t = this.records.get(e);

      if (!t) {
        var _c20 = (0, _utils.getInternalError)("NO_MATCHING_KEY", "".concat(this.name, ": ").concat(e)),
            i = _c20.message;

        throw new Error(i);
      }

      return t;
    }
  }, {
    key: "persist",
    value: function () {
      var _persist5 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee106() {
        return _regenerator["default"].wrap(function _callee106$(_context106) {
          while (1) {
            switch (_context106.prev = _context106.next) {
              case 0:
                _context106.next = 2;
                return this.setJsonRpcRecords(this.values);

              case 2:
                this.events.emit(_.sync);

              case 3:
              case "end":
                return _context106.stop();
            }
          }
        }, _callee106, this);
      }));

      function persist() {
        return _persist5.apply(this, arguments);
      }

      return persist;
    }()
  }, {
    key: "restore",
    value: function () {
      var _restore3 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee107() {
        var e, _c21, t;

        return _regenerator["default"].wrap(function _callee107$(_context107) {
          while (1) {
            switch (_context107.prev = _context107.next) {
              case 0:
                _context107.prev = 0;
                _context107.next = 3;
                return this.getJsonRpcRecords();

              case 3:
                e = _context107.sent;

                if (!(_typeof(e) > "u" || !e.length)) {
                  _context107.next = 6;
                  break;
                }

                return _context107.abrupt("return");

              case 6:
                if (!this.records.size) {
                  _context107.next = 9;
                  break;
                }

                _c21 = (0, _utils.getInternalError)("RESTORE_WILL_OVERRIDE", this.name), t = _c21.message;
                throw this.logger.error(t), new Error(t);

              case 9:
                this.cached = e, this.logger.debug("Successfully Restored records for ".concat(this.name)), this.logger.trace({
                  type: "method",
                  method: "restore",
                  records: this.values
                });
                _context107.next = 15;
                break;

              case 12:
                _context107.prev = 12;
                _context107.t0 = _context107["catch"](0);
                this.logger.debug("Failed to Restore records for ".concat(this.name)), this.logger.error(_context107.t0);

              case 15:
              case "end":
                return _context107.stop();
            }
          }
        }, _callee107, this, [[0, 12]]);
      }));

      function restore() {
        return _restore3.apply(this, arguments);
      }

      return restore;
    }()
  }, {
    key: "registerEventListeners",
    value: function registerEventListeners() {
      var _this28 = this;

      this.events.on(_.created, function (e) {
        var t = _.created;
        _this28.logger.info("Emitting ".concat(t)), _this28.logger.debug({
          type: "event",
          event: t,
          record: e
        }), _this28.persist();
      }), this.events.on(_.updated, function (e) {
        var t = _.updated;
        _this28.logger.info("Emitting ".concat(t)), _this28.logger.debug({
          type: "event",
          event: t,
          record: e
        }), _this28.persist();
      }), this.events.on(_.deleted, function (e) {
        var t = _.deleted;
        _this28.logger.info("Emitting ".concat(t)), _this28.logger.debug({
          type: "event",
          event: t,
          record: e
        }), _this28.persist();
      });
    }
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      if (!this.initialized) {
        var _c22 = (0, _utils.getInternalError)("NOT_INITIALIZED", this.name),
            e = _c22.message;

        throw new Error(e);
      }
    }
  }]);

  return Ut;
}(_types.IJsonRpcHistory);

exports.JsonRpcHistory = Ut;

var Lt = /*#__PURE__*/function (_Wt) {
  _inherits(Lt, _Wt);

  var _super7 = _createSuper(Lt);

  function Lt(e, t) {
    var _this29;

    _classCallCheck(this, Lt);

    _this29 = _super7.call(this, e, t), _this29.core = e, _this29.logger = t, _this29.expirations = new Map(), _this29.events = new _events.EventEmitter(), _this29.name = Et, _this29.version = ft, _this29.cached = [], _this29.initialized = !1, _this29.storagePrefix = O, _this29.init = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee108() {
      return _regenerator["default"].wrap(function _callee108$(_context108) {
        while (1) {
          switch (_context108.prev = _context108.next) {
            case 0:
              _context108.t0 = _this29.initialized;

              if (_context108.t0) {
                _context108.next = 9;
                break;
              }

              _this29.logger.trace("Initialized");

              _context108.next = 5;
              return _this29.restore();

            case 5:
              _this29.cached.forEach(function (i) {
                return _this29.expirations.set(i.target, i);
              });

              _this29.cached = [];

              _this29.registerEventListeners();

              _this29.initialized = !0;

            case 9:
            case "end":
              return _context108.stop();
          }
        }
      }, _callee108);
    })), _this29.has = function (i) {
      try {
        var s = _this29.formatTarget(i);

        return _typeof(_this29.getExpiration(s)) < "u";
      } catch (_unused6) {
        return !1;
      }
    }, _this29.set = function (i, s) {
      _this29.isInitialized();

      var n = _this29.formatTarget(i),
          a = {
        target: n,
        expiry: s
      };

      _this29.expirations.set(n, a), _this29.checkExpiry(n, a), _this29.events.emit(w.created, {
        target: n,
        expiration: a
      });
    }, _this29.get = function (i) {
      _this29.isInitialized();

      var s = _this29.formatTarget(i);

      return _this29.getExpiration(s);
    }, _this29.del = function (i) {
      if (_this29.isInitialized(), _this29.has(i)) {
        var s = _this29.formatTarget(i),
            n = _this29.getExpiration(s);

        _this29.expirations["delete"](s), _this29.events.emit(w.deleted, {
          target: s,
          expiration: n
        });
      }
    }, _this29.on = function (i, s) {
      _this29.events.on(i, s);
    }, _this29.once = function (i, s) {
      _this29.events.once(i, s);
    }, _this29.off = function (i, s) {
      _this29.events.off(i, s);
    }, _this29.removeListener = function (i, s) {
      _this29.events.removeListener(i, s);
    }, _this29.logger = (0, _logger.generateChildLogger)(t, _this29.name);
    return _this29;
  }

  _createClass(Lt, [{
    key: "context",
    get: function get() {
      return (0, _logger.getLoggerContext)(this.logger);
    }
  }, {
    key: "storageKey",
    get: function get() {
      return this.storagePrefix + this.version + "//" + this.name;
    }
  }, {
    key: "length",
    get: function get() {
      return this.expirations.size;
    }
  }, {
    key: "keys",
    get: function get() {
      return Array.from(this.expirations.keys());
    }
  }, {
    key: "values",
    get: function get() {
      return Array.from(this.expirations.values());
    }
  }, {
    key: "formatTarget",
    value: function formatTarget(e) {
      if (typeof e == "string") return (0, _utils.formatTopicTarget)(e);
      if (typeof e == "number") return (0, _utils.formatIdTarget)(e);

      var _c23 = (0, _utils.getInternalError)("UNKNOWN_TYPE", "Target type: ".concat(_typeof(e))),
          t = _c23.message;

      throw new Error(t);
    }
  }, {
    key: "setExpirations",
    value: function () {
      var _setExpirations = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee109(e) {
        return _regenerator["default"].wrap(function _callee109$(_context109) {
          while (1) {
            switch (_context109.prev = _context109.next) {
              case 0:
                _context109.next = 2;
                return this.core.storage.setItem(this.storageKey, e);

              case 2:
              case "end":
                return _context109.stop();
            }
          }
        }, _callee109, this);
      }));

      function setExpirations(_x108) {
        return _setExpirations.apply(this, arguments);
      }

      return setExpirations;
    }()
  }, {
    key: "getExpirations",
    value: function () {
      var _getExpirations = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee110() {
        return _regenerator["default"].wrap(function _callee110$(_context110) {
          while (1) {
            switch (_context110.prev = _context110.next) {
              case 0:
                _context110.next = 2;
                return this.core.storage.getItem(this.storageKey);

              case 2:
                return _context110.abrupt("return", _context110.sent);

              case 3:
              case "end":
                return _context110.stop();
            }
          }
        }, _callee110, this);
      }));

      function getExpirations() {
        return _getExpirations.apply(this, arguments);
      }

      return getExpirations;
    }()
  }, {
    key: "persist",
    value: function () {
      var _persist6 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee111() {
        return _regenerator["default"].wrap(function _callee111$(_context111) {
          while (1) {
            switch (_context111.prev = _context111.next) {
              case 0:
                _context111.next = 2;
                return this.setExpirations(this.values);

              case 2:
                this.events.emit(w.sync);

              case 3:
              case "end":
                return _context111.stop();
            }
          }
        }, _callee111, this);
      }));

      function persist() {
        return _persist6.apply(this, arguments);
      }

      return persist;
    }()
  }, {
    key: "restore",
    value: function () {
      var _restore4 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee112() {
        var e, _c24, t;

        return _regenerator["default"].wrap(function _callee112$(_context112) {
          while (1) {
            switch (_context112.prev = _context112.next) {
              case 0:
                _context112.prev = 0;
                _context112.next = 3;
                return this.getExpirations();

              case 3:
                e = _context112.sent;

                if (!(_typeof(e) > "u" || !e.length)) {
                  _context112.next = 6;
                  break;
                }

                return _context112.abrupt("return");

              case 6:
                if (!this.expirations.size) {
                  _context112.next = 9;
                  break;
                }

                _c24 = (0, _utils.getInternalError)("RESTORE_WILL_OVERRIDE", this.name), t = _c24.message;
                throw this.logger.error(t), new Error(t);

              case 9:
                this.cached = e, this.logger.debug("Successfully Restored expirations for ".concat(this.name)), this.logger.trace({
                  type: "method",
                  method: "restore",
                  expirations: this.values
                });
                _context112.next = 15;
                break;

              case 12:
                _context112.prev = 12;
                _context112.t0 = _context112["catch"](0);
                this.logger.debug("Failed to Restore expirations for ".concat(this.name)), this.logger.error(_context112.t0);

              case 15:
              case "end":
                return _context112.stop();
            }
          }
        }, _callee112, this, [[0, 12]]);
      }));

      function restore() {
        return _restore4.apply(this, arguments);
      }

      return restore;
    }()
  }, {
    key: "getExpiration",
    value: function getExpiration(e) {
      var t = this.expirations.get(e);

      if (!t) {
        var _c25 = (0, _utils.getInternalError)("NO_MATCHING_KEY", "".concat(this.name, ": ").concat(e)),
            i = _c25.message;

        throw this.logger.error(i), new Error(i);
      }

      return t;
    }
  }, {
    key: "checkExpiry",
    value: function checkExpiry(e, t) {
      var i = t.expiry;
      (0, _time.toMiliseconds)(i) - Date.now() <= 0 && this.expire(e, t);
    }
  }, {
    key: "expire",
    value: function expire(e, t) {
      this.expirations["delete"](e), this.events.emit(w.expired, {
        target: e,
        expiration: t
      });
    }
  }, {
    key: "checkExpirations",
    value: function checkExpirations() {
      var _this30 = this;

      this.core.relayer.connected && this.expirations.forEach(function (e, t) {
        return _this30.checkExpiry(t, e);
      });
    }
  }, {
    key: "registerEventListeners",
    value: function registerEventListeners() {
      var _this31 = this;

      this.core.heartbeat.on(_heartbeat.HEARTBEAT_EVENTS.pulse, function () {
        return _this31.checkExpirations();
      }), this.events.on(w.created, function (e) {
        var t = w.created;
        _this31.logger.info("Emitting ".concat(t)), _this31.logger.debug({
          type: "event",
          event: t,
          data: e
        }), _this31.persist();
      }), this.events.on(w.expired, function (e) {
        var t = w.expired;
        _this31.logger.info("Emitting ".concat(t)), _this31.logger.debug({
          type: "event",
          event: t,
          data: e
        }), _this31.persist();
      }), this.events.on(w.deleted, function (e) {
        var t = w.deleted;
        _this31.logger.info("Emitting ".concat(t)), _this31.logger.debug({
          type: "event",
          event: t,
          data: e
        }), _this31.persist();
      });
    }
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      if (!this.initialized) {
        var _c26 = (0, _utils.getInternalError)("NOT_INITIALIZED", this.name),
            e = _c26.message;

        throw new Error(e);
      }
    }
  }]);

  return Lt;
}(_types.IExpirer);

exports.Expirer = Lt;

var Ft = /*#__PURE__*/function (_Xt) {
  _inherits(Ft, _Xt);

  var _super8 = _createSuper(Ft);

  function Ft(e, t) {
    var _this32;

    _classCallCheck(this, Ft);

    _this32 = _super8.call(this, e, t), _this32.projectId = e, _this32.logger = t, _this32.name = J, _this32.initialized = !1, _this32.init = /*#__PURE__*/function () {
      var _ref76 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee113(i) {
        return _regenerator["default"].wrap(function _callee113$(_context113) {
          while (1) {
            switch (_context113.prev = _context113.next) {
              case 0:
                _context113.t0 = (0, _utils.isReactNative)() || !(0, _utils.isBrowser)();

                if (_context113.t0) {
                  _context113.next = 5;
                  break;
                }

                _this32.verifyUrl = (i === null || i === void 0 ? void 0 : i.verifyUrl) || de;
                _context113.next = 5;
                return _this32.createIframe();

              case 5:
              case "end":
                return _context113.stop();
            }
          }
        }, _callee113);
      }));

      return function (_x109) {
        return _ref76.apply(this, arguments);
      };
    }(), _this32.register = /*#__PURE__*/function () {
      var _ref77 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee114(i) {
        var s;
        return _regenerator["default"].wrap(function _callee114$(_context114) {
          while (1) {
            switch (_context114.prev = _context114.next) {
              case 0:
                _context114.t0 = _this32.initialized;

                if (_context114.t0) {
                  _context114.next = 4;
                  break;
                }

                _context114.next = 4;
                return _this32.init();

              case 4:
                if (!_this32.iframe) {
                  _context114.next = 6;
                  break;
                }

                try {
                  (s = _this32.iframe.contentWindow) == null || s.postMessage(i.attestationId, _this32.verifyUrl), _this32.logger.info("postMessage sent: ".concat(i.attestationId, " ").concat(_this32.verifyUrl));
                } catch (_unused7) {}

              case 6:
              case "end":
                return _context114.stop();
            }
          }
        }, _callee114);
      }));

      return function (_x110) {
        return _ref77.apply(this, arguments);
      };
    }(), _this32.resolve = /*#__PURE__*/function () {
      var _ref78 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee115(i) {
        var s, n, a;
        return _regenerator["default"].wrap(function _callee115$(_context115) {
          while (1) {
            switch (_context115.prev = _context115.next) {
              case 0:
                if (!_this32.isDevEnv) {
                  _context115.next = 2;
                  break;
                }

                return _context115.abrupt("return", "");

              case 2:
                _this32.logger.info("resolving attestation: ".concat(i.attestationId));

                n = _this32.startAbortTimer(_time.FIVE_SECONDS);
                _context115.next = 6;
                return fetch("".concat(_this32.verifyUrl, "/attestation/").concat(i.attestationId), {
                  signal: _this32.abortController.signal
                });

              case 6:
                a = _context115.sent;
                clearTimeout(n);

                if (!(a.status === 200)) {
                  _context115.next = 20;
                  break;
                }

                _context115.next = 11;
                return a.json();

              case 11:
                _context115.t1 = s = _context115.sent;

                if (!(_context115.t1 == null)) {
                  _context115.next = 16;
                  break;
                }

                _context115.t2 = void 0;
                _context115.next = 17;
                break;

              case 16:
                _context115.t2 = s.origin;

              case 17:
                _context115.t0 = _context115.t2;
                _context115.next = 21;
                break;

              case 20:
                _context115.t0 = "";

              case 21:
                return _context115.abrupt("return", _context115.t0);

              case 22:
              case "end":
                return _context115.stop();
            }
          }
        }, _callee115);
      }));

      return function (_x111) {
        return _ref78.apply(this, arguments);
      };
    }(), _this32.createIframe = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee116() {
      return _regenerator["default"].wrap(function _callee116$(_context116) {
        while (1) {
          switch (_context116.prev = _context116.next) {
            case 0:
              _context116.prev = 0;
              _context116.next = 3;
              return Promise.race([new Promise(function (i, s) {
                if (document.getElementById(J)) return i();
                var n = document.createElement("iframe");
                n.setAttribute("id", J), n.setAttribute("src", "".concat(_this32.verifyUrl, "/").concat(_this32.projectId)), n.style.display = "none", n.addEventListener("load", function () {
                  _this32.initialized = !0, i();
                }), n.addEventListener("error", function (a) {
                  s(a);
                }), document.body.append(n), _this32.iframe = n;
              }), new Promise(function (i) {
                setTimeout(function () {
                  return i("iframe load timeout");
                }, (0, _time.toMiliseconds)(_time.ONE_SECOND / 2));
              })]);

            case 3:
              _context116.next = 8;
              break;

            case 5:
              _context116.prev = 5;
              _context116.t0 = _context116["catch"](0);
              _this32.logger.error("Verify iframe failed to load: ".concat(_this32.verifyUrl)), _this32.logger.error(_context116.t0);

            case 8:
            case "end":
              return _context116.stop();
          }
        }
      }, _callee116, null, [[0, 5]]);
    })), _this32.logger = (0, _logger.generateChildLogger)(t, _this32.name), _this32.verifyUrl = de, _this32.abortController = new AbortController(), _this32.isDevEnv = (0, _utils.isNode)() && process.env.IS_VITEST;
    return _this32;
  }

  _createClass(Ft, [{
    key: "context",
    get: function get() {
      return (0, _logger.getLoggerContext)(this.logger);
    }
  }, {
    key: "startAbortTimer",
    value: function startAbortTimer(e) {
      var _this33 = this;

      return setTimeout(function () {
        return _this33.abortController.abort();
      }, (0, _time.toMiliseconds)(e));
    }
  }]);

  return Ft;
}(_types.IVerify);

exports.Verify = Ft;

var Cr = Object.defineProperty,
    $t = Object.getOwnPropertySymbols,
    _r = Object.prototype.hasOwnProperty,
    Rr = Object.prototype.propertyIsEnumerable,
    Mt = function Mt(r, e, t) {
  return e in r ? Cr(r, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : r[e] = t;
},
    Kt = function Kt(r, e) {
  for (var t in e || (e = {})) {
    _r.call(e, t) && Mt(r, t, e[t]);
  }

  if ($t) {
    var _iterator5 = _createForOfIteratorHelper($t(e)),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var t = _step5.value;
        Rr.call(e, t) && Mt(r, t, e[t]);
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }

  return r;
};

var H = /*#__PURE__*/function (_Zt) {
  _inherits(H, _Zt);

  var _super9 = _createSuper(H);

  function H(e) {
    var _this34;

    _classCallCheck(this, H);

    _this34 = _super9.call(this, e), _this34.protocol = ce, _this34.version = Ge, _this34.name = Y, _this34.events = new _events.EventEmitter(), _this34.initialized = !1, _this34.on = function (i, s) {
      return _this34.events.on(i, s);
    }, _this34.once = function (i, s) {
      return _this34.events.once(i, s);
    }, _this34.off = function (i, s) {
      return _this34.events.off(i, s);
    }, _this34.removeListener = function (i, s) {
      return _this34.events.removeListener(i, s);
    }, _this34.projectId = e === null || e === void 0 ? void 0 : e.projectId, _this34.relayUrl = (e === null || e === void 0 ? void 0 : e.relayUrl) || le;
    var t = _typeof(e === null || e === void 0 ? void 0 : e.logger) < "u" && typeof (e === null || e === void 0 ? void 0 : e.logger) != "string" ? e.logger : (0, _logger.pino)((0, _logger.getDefaultLoggerOptions)({
      level: (e === null || e === void 0 ? void 0 : e.logger) || Ye.logger
    }));
    _this34.logger = (0, _logger.generateChildLogger)(t, _this34.name), _this34.heartbeat = new _heartbeat.HeartBeat(), _this34.crypto = new vt(_assertThisInitialized(_this34), _this34.logger, e === null || e === void 0 ? void 0 : e.keychain), _this34.history = new Ut(_assertThisInitialized(_this34), _this34.logger), _this34.expirer = new Lt(_assertThisInitialized(_this34), _this34.logger), _this34.storage = e != null && e.storage ? e.storage : new _keyvaluestorage["default"](Kt(Kt({}, Je), e === null || e === void 0 ? void 0 : e.storageOptions)), _this34.relayer = new Pt({
      core: _assertThisInitialized(_this34),
      logger: _this34.logger,
      relayUrl: _this34.relayUrl,
      projectId: _this34.projectId
    }), _this34.pairing = new Nt(_assertThisInitialized(_this34), _this34.logger), _this34.verify = new Ft(_this34.projectId || "", _this34.logger);
    return _this34;
  }

  _createClass(H, [{
    key: "context",
    get: function get() {
      return (0, _logger.getLoggerContext)(this.logger);
    }
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee117() {
        return _regenerator["default"].wrap(function _callee117$(_context117) {
          while (1) {
            switch (_context117.prev = _context117.next) {
              case 0:
                _context117.t0 = this.initialized;

                if (_context117.t0) {
                  _context117.next = 4;
                  break;
                }

                _context117.next = 4;
                return this.initialize();

              case 4:
              case "end":
                return _context117.stop();
            }
          }
        }, _callee117, this);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee118() {
        return _regenerator["default"].wrap(function _callee118$(_context118) {
          while (1) {
            switch (_context118.prev = _context118.next) {
              case 0:
                this.logger.trace("Initialized");
                _context118.prev = 1;
                _context118.next = 4;
                return this.crypto.init();

              case 4:
                _context118.next = 6;
                return this.history.init();

              case 6:
                _context118.next = 8;
                return this.expirer.init();

              case 8:
                _context118.next = 10;
                return this.relayer.init();

              case 10:
                _context118.next = 12;
                return this.heartbeat.init();

              case 12:
                _context118.next = 14;
                return this.pairing.init();

              case 14:
                this.initialized = !0;
                this.logger.info("Core Initialization Success");
                _context118.next = 21;
                break;

              case 18:
                _context118.prev = 18;
                _context118.t0 = _context118["catch"](1);
                throw this.logger.warn("Core Initialization Failure at epoch ".concat(Date.now()), _context118.t0), this.logger.error(_context118.t0.message), _context118.t0;

              case 21:
              case "end":
                return _context118.stop();
            }
          }
        }, _callee118, this, [[1, 18]]);
      }));

      function initialize() {
        return _initialize.apply(this, arguments);
      }

      return initialize;
    }()
  }], [{
    key: "init",
    value: function () {
      var _init2 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee119(e) {
        var t, i;
        return _regenerator["default"].wrap(function _callee119$(_context119) {
          while (1) {
            switch (_context119.prev = _context119.next) {
              case 0:
                t = new H(e);
                _context119.next = 3;
                return t.initialize();

              case 3:
                _context119.next = 5;
                return t.crypto.getClientId();

              case 5:
                i = _context119.sent;
                _context119.next = 8;
                return t.storage.setItem(lt, i);

              case 8:
                return _context119.abrupt("return", t);

              case 9:
              case "end":
                return _context119.stop();
            }
          }
        }, _callee119);
      }));

      function init(_x112) {
        return _init2.apply(this, arguments);
      }

      return init;
    }()
  }]);

  return H;
}(_types.ICore);

exports["default"] = H;
var Tr = H;
exports.Core = Tr;